<template>
<div class="checkout-flow">
    <!-- Error Toast -->
    <div v-if="toastMessage" class="error-toast">
        <span>{{ toastMessage }}</span>
        <button class="toast-close" @click="toastMessage = ''">&times;</button>
    </div>

    <!-- Priority Physician Review — offered once the order is captured, charged
         separately. Declining or failing here cannot touch the paid order; either
         answer continues to the same confirmation page. -->
    <fast-track-upsell-modal
        v-if="fastTrackOfferOpen && fastTrackAddon"
        :addon="fastTrackAddon"
        :payment-method="paymentInfo.paymentMethod || 'card'"
        :base-url="baseUrl"
        :user-id="paymentInfo.user_id || (user && user.id) || ''"
        :first-name="(user && user.first_name) || ''"
        :last-name="(user && user.last_name) || ''"
        :email="(user && user.email) || ''"
        :shipping-address="customerInfo"
        :tracking-session-id="trackingSessionId"
        :ip-address="people.ip_address"
        @close="closeFastTrackOffer"
    />

    <!-- Processing payment popup. Hidden while the add-on offer is up: the charge
         that spinner belongs to has already succeeded. -->
    <div v-if="submitted && !fastTrackOfferOpen" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#52b2cf" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <a :href="supportPhoneTel" class="link-block-114 w-inline-block"><img src="@/assets/images/material-symbols_call-sharp.svg" loading="lazy" width="16" alt="" class="image-699">
                        <div class="link-90">{{ supportPhone }}</div>
                    </a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="(max-width: 767px) 100vw, 511.9068298339844px" srcset="@/assets/images/dark-logo-p-500.png 500w, @/assets/images/dark-logo.png 512w" alt="" src="@/assets/images/dark-logo.png" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el > 10">
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651"></a>
                </div>
                <div class="mobile-nav-links">
                    <a :href="supportPhoneTel" class="link-block-109 w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-692"></a>
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()" v-if="active_el > 1"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="" class="image-651" style="height:15px;"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress" :style="{ width: Math.round((active_el / totalSteps) * 100) + '%' }"></div>
            </div>
        </div>
    </section>
    <section class="section_checkout-flow">
        <div class="flow_wrap">

            <div class="step_forminfo_div" v-if="active_el === 1">
                <div class="question-container-2">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d0869fca5" @submit.prevent="handleSubmit">
                            <div class="enroll-slide-1-div-copy _2"><img sizes="(max-width: 767px) 100vw, 640.9866943359375px" srcset="@/assets/images/stepsimage_teledoc_nS-p-500.png 500w, @/assets/images/stepsimage_teledoc_nS.png 641w" alt="" src="@/assets/images/stepsimage_teledoc_nS.png" loading="lazy" class="enroll-top-image">
                                <div class="enroll-header">Welcome to RxPros!</div>
                                <p class="enroll-sub">Your treatment plan is created only after review by a board-certified provider licensed in your state.<br>Please answer accurately so we can help you reach your goals</p>
                                <div class="enroll-3-things-div">
                                    <div class="enroll-bullet-div rx"><img loading="lazy" src="@/assets/images/cf1.png" alt="" class="enroll-bullet-image">
                                        <div class="div-block-2266">
                                            <div class="enroll-bullet-text _2">Pre-Qualification</div>
                                            <div class="enroll-bullet-subtext">A brief intake designed to understand your needs and medical history</div>
                                        </div>
                                    </div>
                                    <div class="enroll-bullet-div rx"><img loading="lazy" src="@/assets/images/cf2.png" alt="" class="enroll-bullet-image">
                                        <div class="div-block-2266">
                                            <div class="enroll-bullet-text _2">Medical Review</div>
                                            <div class="enroll-bullet-subtext">Your information is evaluated by a licensed provider using established clinical guidelines</div>
                                        </div>
                                    </div>
                                    <div class="enroll-bullet-div last rx"><img loading="lazy" src="@/assets/images/cf3.png" alt="" class="enroll-bullet-image">
                                        <div class="div-block-2266">
                                            <div class="enroll-bullet-text _2">Secure Home Delivery</div>
                                            <div class="enroll-bullet-subtext">Approved treatments are shipped quickly and discreetly from licensed U.S. pharmacies, at no extra cost</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="enroll-form-button-div"><input type="submit" data-wait="Please wait..." class="enroll-form-submit-button top w-button" value="Start my Free Visit"></div>
                                <div class="enroll-disclaimer-div _1st"><label class="w-checkbox enroll-checkbox-field"><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" class="w-checkbox-input enroll-checkbox top" v-model="people.agreed_to_terms" required=""><span class="enroll-checkbox-label w-form-label" for="checkbox-3">I Agree to Rx Pros&#x27; <a  target="_blank" href="https://rxpros.com/terms" class="enroll-checkbox-link">Terms</a>, <a href="https://rxpros.com/privacy" target="_blank" class="enroll-checkbox-link">Privacy Policy</a> and consent to <a target="_blank" href="https://rxpros.com/telehealth" class="enroll-checkbox-link">Telehealth</a></span></label></div>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step_forminfo_div" v-if="active_el === 2">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Start Your Medical Review</div>
                    <div class="text-block-1686">We need a few details to make sure care is provided by licensed provider in your state.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d0869fd23" @submit.prevent="handleSubmit">
                            <div class="form-field-label">State*</div>
                            <!--<div class="selectwrap">
                                <span class="select-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0 text-secondary-400" aria-hidden="true" width="18" height="18">
                                        <path d="M9 17.25C8.58579 17.25 8.25 17.5858 8.25 18C8.25 18.4142 8.58579 18.75 9 18.75H15C15.4142 18.75 15.75 18.4142 15.75 18C15.75 17.5858 15.4142 17.25 15 17.25H9Z">
                                        </path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C11.2919 1.25 10.6485 1.45282 9.95055 1.79224C9.27585 2.12035 8.49642 2.60409 7.52286 3.20832L5.45628 4.4909C4.53509 5.06261 3.79744 5.5204 3.2289 5.95581C2.64015 6.40669 2.18795 6.86589 1.86131 7.46263C1.53535 8.05812 1.38857 8.69174 1.31819 9.4407C1.24999 10.1665 1.24999 11.0541 1.25 12.1672V13.7799C1.24999 15.6837 1.24998 17.1866 1.4027 18.3616C1.55937 19.567 1.88856 20.5401 2.63236 21.3094C3.37958 22.0824 4.33046 22.4277 5.50761 22.5914C6.64849 22.75 8.10556 22.75 9.94185 22.75H14.0581C15.8944 22.75 17.3515 22.75 18.4924 22.5914C19.6695 22.4277 20.6204 22.0824 21.3676 21.3094C22.1114 20.5401 22.4406 19.567 22.5973 18.3616C22.75 17.1866 22.75 15.6838 22.75 13.7799V12.1672C22.75 11.0541 22.75 10.1665 22.6818 9.4407C22.6114 8.69174 22.4646 8.05812 22.1387 7.46263C21.8121 6.86589 21.3599 6.40669 20.7711 5.95581C20.2026 5.5204 19.4649 5.06262 18.5437 4.49091L16.4771 3.20831C15.5036 2.60409 14.7241 2.12034 14.0494 1.79224C13.3515 1.45282 12.7081 1.25 12 1.25ZM8.27953 4.50412C9.29529 3.87371 10.0095 3.43153 10.6065 3.1412C11.1882 2.85833 11.6002 2.75 12 2.75C12.3998 2.75 12.8118 2.85833 13.3935 3.14119C13.9905 3.43153 14.7047 3.87371 15.7205 4.50412L17.7205 5.74537C18.6813 6.34169 19.3559 6.76135 19.8591 7.1467C20.3487 7.52164 20.6303 7.83106 20.8229 8.18285C21.0162 8.53589 21.129 8.94865 21.1884 9.58104C21.2492 10.2286 21.25 11.0458 21.25 12.2039V13.725C21.25 15.6959 21.2485 17.1012 21.1098 18.1683C20.9736 19.2163 20.717 19.8244 20.2892 20.2669C19.8649 20.7058 19.2871 20.9664 18.2858 21.1057C17.2602 21.2483 15.9075 21.25 14 21.25H10C8.09247 21.25 6.73983 21.2483 5.71422 21.1057C4.71286 20.9664 4.13514 20.7058 3.71079 20.2669C3.28301 19.8244 3.02642 19.2163 2.89019 18.1683C2.75149 17.1012 2.75 15.6959 2.75 13.725V12.2039C2.75 11.0458 2.75076 10.2286 2.81161 9.58104C2.87103 8.94865 2.98385 8.53589 3.17709 8.18285C3.36965 7.83106 3.65133 7.52164 4.14092 7.1467C4.6441 6.76135 5.31869 6.34169 6.27953 5.74537L8.27953 4.50412Z">
                                        </path>
                                    </svg>
                                </span>-->
                            <select id="State-4" name="State-4" data-name="State 4" required class="checkout-flow-dropdown w-select" v-model="people.state" :class="{ 'field-error': fieldErrors.state }">
                                <option value="" disabled selected>State...</option>
                                <option value="Alaska">Alaska</option>
                                <option value="Alabama">Alabama</option>
                                <option value="Arizona">Arizona</option>
                                <option value="Arkansas">Arkansas</option>
                                <option value="California">California</option>
                                <option value="Colorado">Colorado</option>
                                <option value="Connecticut">Connecticut</option>
                                <option value="Delaware">Delaware</option>
                                <option value="Florida">Florida</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Hawaii">Hawaii</option>
                                <option value="Idaho">Idaho</option>
                                <option value="Illinois">Illinois</option>
                                <option value="Indiana">Indiana</option>
                                <option value="Iowa">Iowa</option>
                                <option value="Kansas">Kansas</option>
                                <option value="Kentucky">Kentucky</option>
                                <option value="Maine">Maine</option>
                                <option value="Maryland">Maryland</option>
                                <option value="Massachusetts">Massachusetts</option>
                                <option value="Michigan">Michigan</option>
                                <option value="Minnesota">Minnesota</option>
                                <option value="Missouri">Missouri</option>
                                <option value="Montana">Montana</option>
                                <option value="Nebraska">Nebraska</option>
                                <option value="Nevada">Nevada</option>
                                <option value="New Hampshire">New Hampshire</option>
                                <option value="New Jersey">New Jersey</option>
                                <option value="New Mexico">New Mexico</option>
                                <option value="New York">New York</option>
                                <option value="North Carolina">North Carolina</option>
                                <option value="North Dakota">North Dakota</option>
                                <option value="Ohio">Ohio</option>
                                <option value="Oklahoma">Oklahoma</option>
                                <option value="Oregon">Oregon</option>
                                <option value="Pennsylvania">Pennsylvania</option>
                                <option value="Rhode Island">Rhode Island</option>
                                <option value="South Carolina">South Carolina</option>
                                <option value="South Dakota">South Dakota</option>
                                <option value="Tennessee">Tennessee</option>
                                <option value="Texas">Texas</option>
                                <option value="Utah">Utah</option>
                                <option value="Vermont">Vermont</option>
                                <option value="Virginia">Virginia</option>
                                <option value="Washington">Washington</option>
                                <option value="West Virginia">West Virginia</option>
                                <option value="Wisconsin">Wisconsin</option>
                                <option value="Wyoming">Wyoming</option>
                            </select>
                            
                            <div class="form-field-label">Sex assigned at birth*</div>
                            <!--<div class="selectwrap">
                                <span class="select-icon" aria-hidden="true"> <svg viewBox="0 0 16 16" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0 text-secondary-400" aria-hidden="true" width="18" height="18">
                                        <path d="M3.47845 6.89783C3.47845 4.95347 5.05467 3.37725 6.99903 3.37725C8.94339 3.37725 10.5196 4.95347 10.5196 6.89783C10.5196 8.84217 8.94328 10.4184 6.99889 10.4184C5.05456 10.4184 3.47845 8.84222 3.47845 6.89783ZM6.99903 2.19631C4.40245 2.19631 2.29751 4.30125 2.29751 6.89783C2.29751 9.29443 4.09049 11.2721 6.40843 11.5626V12.5533H5.53082C5.20471 12.5533 4.94035 12.8177 4.94035 13.1438C4.94035 13.4699 5.20471 13.7342 5.53082 13.7342H6.40847L6.40858 15.1993C6.4086 15.5255 6.67299 15.7898 6.99909 15.7898C7.3252 15.7897 7.58954 15.5254 7.58952 15.1993L7.58941 13.7342H8.46728C8.79339 13.7342 9.05775 13.4699 9.05775 13.1438C9.05775 12.8177 8.79339 12.5533 8.46728 12.5533H7.58936V11.5626C9.90729 11.2721 11.7005 9.29447 11.7005 6.89783C11.7005 4.30125 9.59561 2.19631 6.99903 2.19631Z">
                                        </path>
                                        <path fill-rule="evenodd" d="M10.2124 0.745546C10.2124 0.532708 10.385 0.360168 10.5978 0.360168H13.167C13.3798 0.360168 13.5524 0.532708 13.5524 0.745546V3.31473C13.5524 3.52757 13.3798 3.70011 13.167 3.70011C12.9542 3.70011 12.7816 3.52757 12.7816 3.31473V1.67593L10.441 4.01652C11.1 4.7987 11.497 5.80878 11.497 6.91159C11.497 9.3947 9.48407 11.4077 7.00096 11.4077C4.51784 11.4077 2.50488 9.3947 2.50488 6.91159C2.50488 4.42848 4.51784 2.41552 7.00096 2.41552C8.10377 2.41552 9.11384 2.81257 9.89603 3.47151L12.2366 1.13092H10.5978C10.385 1.13092 10.2124 0.958384 10.2124 0.745546ZM7.00096 3.18627C4.94352 3.18627 3.27564 4.85415 3.27564 6.91159C3.27564 8.96902 4.94352 10.6369 7.00096 10.6369C9.05839 10.6369 10.7263 8.96902 10.7263 6.91159C10.7263 4.85415 9.05839 3.18627 7.00096 3.18627Z">
                                        </path>
                                    </svg>
                                </span>-->
                            <select id="field-2" name="field-2" data-name="Field 2" class="checkout-flow-dropdown w-select" v-model="people.gender" :class="{ 'field-error': fieldErrors.gender }">
                                <option value="">Select an option...</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                            
                            <div class="form-field-label">Date of birth*</div>
                            <!--<div class="selectwrap">
                                    <span class="select-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="#a3b19e" xmlns="http://www.w3.org/2000/svg" class="size-full shrink-0" aria-hidden="true" width="18" height="18">
                                            <path d="M17 14C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13C16 13.5523 16.4477 14 17 14Z">
                                            </path>
                                            <path d="M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18Z">
                                            </path>
                                            <path d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z">
                                            </path>
                                            <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z">
                                            </path>
                                            <path d="M7 14C7.55229 14 8 13.5523 8 13C8 12.4477 7.55229 12 7 12C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14Z">
                                            </path>
                                            <path d="M7 18C7.55229 18 8 17.5523 8 17C8 16.4477 7.55229 16 7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18Z">
                                            </path>
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.75C7.41421 1.75 7.75 2.08579 7.75 2.5V3.26272C8.412 3.24999 9.14133 3.24999 9.94346 3.25H14.0564C14.8586 3.24999 15.588 3.24999 16.25 3.26272V2.5C16.25 2.08579 16.5858 1.75 17 1.75C17.4142 1.75 17.75 2.08579 17.75 2.5V3.32709C18.0099 3.34691 18.2561 3.37182 18.489 3.40313C19.6614 3.56076 20.6104 3.89288 21.3588 4.64124C22.1071 5.38961 22.4392 6.33855 22.5969 7.51098C22.75 8.65018 22.75 10.1058 22.75 11.9435V14.0564C22.75 15.8941 22.75 17.3498 22.5969 18.489C22.4392 19.6614 22.1071 20.6104 21.3588 21.3588C20.6104 22.1071 19.6614 22.4392 18.489 22.5969C17.3498 22.75 15.8942 22.75 14.0565 22.75H9.94359C8.10585 22.75 6.65018 22.75 5.51098 22.5969C4.33856 22.4392 3.38961 22.1071 2.64124 21.3588C1.89288 20.6104 1.56076 19.6614 1.40314 18.489C1.24997 17.3498 1.24998 15.8942 1.25 14.0564V11.9436C1.24998 10.1058 1.24997 8.65019 1.40314 7.51098C1.56076 6.33855 1.89288 5.38961 2.64124 4.64124C3.38961 3.89288 4.33856 3.56076 5.51098 3.40313C5.7439 3.37182 5.99006 3.34691 6.25 3.32709V2.5C6.25 2.08579 6.58579 1.75 7 1.75ZM5.71085 4.88976C4.70476 5.02502 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02502 6.70476 2.88976 7.71085C2.86685 7.88123 2.8477 8.06061 2.83168 8.25H21.1683C21.1523 8.06061 21.1331 7.88124 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02502 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976ZM2.75 12C2.75 11.146 2.75032 10.4027 2.76309 9.75H21.2369C21.2497 10.4027 21.25 11.146 21.25 12V14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25H10C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981C3.27869 19.8749 3.02502 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14V12Z">
                                            </path>
                                        </svg></span>-->
                            <div class="flex-input-div dob">
                                <input class="checkout-flow-input thirds w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="birth-month" data-name="birth month" placeholder="MM" type="text" id="birth-month" required v-model="people.dob.mm" @input="autoAdvanceDobField('birth-month', 'birth-day', 2)" @keypress="numericOnly" :class="{ 'field-error': fieldErrors.dob_mm }">
                                <input class="checkout-flow-input thirds w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="birth-day" data-name="birth day" placeholder="DD" type="text" id="birth-day" required v-model="people.dob.dd" @input="autoAdvanceDobField('birth-day', 'birth-year', 2)" @keypress="numericOnly" :class="{ 'field-error': fieldErrors.dob_dd }">
                                <input class="checkout-flow-input thirds w-input" maxlength="4" pattern="[0-9]*" inputmode="numeric" name="birth-year" data-name="birth year" placeholder="YYYY" type="text" id="birth-year" required v-model="people.dob.yyyy" @keypress="numericOnly" :class="{ 'field-error': fieldErrors.dob_yyyy }">
                            
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="flow-ctrls-div first">
                        <a href="#" class="continue-button step first w-button" @click.prevent="handleSubmit">Continue <span class="text-span-426">-&gt;</span></a>
                    </div>
                </div>
            </div>

            <div class="step_forminfo_div" v-if="active_el === 3">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers line-break">What are your health goals?</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d0869fd4c">
                            <div class="category-select-div"><label class="w-checkbox checkbox-field-full-box">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-category" :class="{'w--redirected-checked': people.categories.weightLoss}"></div><input type="checkbox" name="checkbox-weightloss" id="checkbox-weightloss" data-name="Checkbox Weight Loss" style="opacity:0;position:absolute;z-index:-1" v-model="people.categories.weightLoss"><span class="checkboxlabel-fullbox w-form-label" for="checkbox-weightloss">Weight Loss<br><span class="checkbox-label-info-span">A structured weight loss path that may include prescription treatment, nutrition guidance, and ongoing clinical oversight<br></span></span>
                                    <div class="checkbox-img-div weight"><img loading="lazy" src="@/assets/images/goals1.jpg" alt=""></div>
                                </label><label class="w-checkbox checkbox-field-full-box">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-category" :class="{'w--redirected-checked': people.categories.mind}"></div><input type="checkbox" name="checkbox-mind" id="checkbox-mind" data-name="Checkbox Mind" style="opacity:0;position:absolute;z-index:-1" v-model="people.categories.mind"><span class="checkboxlabel-fullbox w-form-label" for="checkbox-mind">Mind <span class="new-tag">New</span><br><span class="checkbox-label-info-span">A care path designed to support focus, mood, and mental performance under medical supervision<br></span></span>
                                    <div class="checkbox-img-div mind"><img loading="lazy" src="@/assets/images/goals3.jpg" alt=""></div>
                                </label><label class="w-checkbox checkbox-field-full-box">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-category" :class="{'w--redirected-checked': people.categories.wellness}"></div><input type="checkbox" name="checkbox-wellness" id="checkbox-wellness" data-name="Checkbox Wellness" style="opacity:0;position:absolute;z-index:-1" v-model="people.categories.wellness"><span class="checkboxlabel-fullbox w-form-label" for="checkbox-wellness">Wellness <span class="new-tag">New</span><br><span class="checkbox-label-info-span">A general wellness path centered on preventive care, balance, and physician-guided health optimization<br></span></span>
                                    <div class="checkbox-img-div body"><img loading="lazy" src="@/assets/images/goals4.jpg" alt=""></div>
                                </label><label class="w-checkbox checkbox-field-full-box">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-category" :class="{'w--redirected-checked': people.categories.longevity}"></div><input type="checkbox" name="checkbox-longevity" id="checkbox-longevity" data-name="Checkbox Longevity" style="opacity:0;position:absolute;z-index:-1" v-model="people.categories.longevity"><span class="checkboxlabel-fullbox w-form-label" for="checkbox-longevity">Longevity <span class="new-tag">New</span><br><span class="checkbox-label-info-span">A wellness-focused path designed to support long-term health, energy, and daily functioning<br></span></span>
                                    <div class="checkbox-img-div longevity"><img loading="lazy" src="@/assets/images/goals3.jpg" alt=""></div>
                                </label></div>
                            <div class="flow-ctrls-div">
                                <a href="#" class="form-back-link w-inline-block" @click.prevent="GoBack()">
                                    <div class="text-block-1719">&lt;-</div>
                                    <div class="text-block-1718">Back</div>
                                </a>
                                <a href="#" class="continue-button step w-button" @click.prevent="handleSubmit">Continue <span class="text-span-426">-&gt;</span></a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step_forminfo_div" v-if="active_el === 4">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Let&#x27;s Review Some Basics</div>
                    <div class="text-block-1686">Height and weight are used as part of a standard clinical evaluation.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d0869fd9b">
                            <div class="flex-input-div">
                                <div class="flow-form-half-div">
                                    <div class="form-field-label">Height*</div><input class="checkout-flow-input w-input" maxlength="1" pattern="[0-9]*" inputmode="numeric" name="height-feet" data-name="height feet" placeholder="Feet (eg. 5)" type="text" id="height-feet" required v-model="people.height.foot" @keypress="numericOnly" @input="autoAdvanceDobField('height-feet', 'height-inches', 1)" :class="{ 'field-error': fieldErrors.height_foot }">
                                </div>
                                <div class="flow-form-half-div"><input class="checkout-flow-input w-input" maxlength="2" pattern="[0-9]*" inputmode="numeric" name="height-inches" data-name="height inches" placeholder="Inches (eg. 3)" type="text" id="height-inches" required v-model="people.height.inches" @keypress="numericOnly" @input="validateInches(); autoAdvanceDobField('height-inches', 'Weight-pounds', 2)" :class="{ 'field-error': fieldErrors.height_inches }"></div>
                            </div>
                            <div class="form-field-label">Weight*</div><input class="checkout-flow-input w-input" maxlength="3" pattern="[0-9]*" inputmode="numeric" name="Weight-pounds" data-name="Weight pounds" placeholder="Pounds (eg. 200)" type="text" id="Weight-pounds" required v-model="people.weight" @keypress="numericOnly" :class="{ 'field-error': fieldErrors.weight }">
                            <div class="bmi-div"><img loading="lazy" src="@/assets/images/icon_info.svg" alt="" class="image-686">
                                <div class="bmi-text">Your BMI Score is {{ bmi_calculated }}</div>
                            </div>
                            <div class="flow-ctrls-div">
                                <a href="#" class="form-back-link w-inline-block hide-back-mobile" @click.prevent="GoBack()">
                                    <div class="text-block-1719">&lt;-</div>
                                    <div class="text-block-1718">Back</div>
                                </a>
                                <a href="#" class="continue-button step w-button" @click.prevent="handleSubmit">Continue <span class="text-span-426">-&gt;</span></a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="quizquestiondiv2-copy ad" v-if="active_el === 5">
                <div class="quizquestionheader-cop">One Simple Price. <br>All Dosages. <br>No Membership or Hidden Fees</div>
                <p class="paragraph-208 center">Dosage adjustments don&#x27;t change your price. A licensed provider will help determine what&#x27;s appropriate for you</p>
                <div class="quiz-img-div ad flow"><img sizes="100vw" srcset="@/assets/images/comparision-quiz-p-500.png 500w, @/assets/images/comparision-quiz-p-800.png 800w, @/assets/images/comparision-quiz-p-1080.png 1080w, @/assets/images/comparision-quiz-p-1600.png 1600w, @/assets/images/comparision-quiz-p-2000.png 2000w, @/assets/images/comparision-quiz.png 2560w" alt="" src="@/assets/images/comparision-quiz.png" loading="lazy" class="image-694 flow outline">
                    <p class="paragraph-222">Dosage and medication selection are determined by a licensed medical provider based on your health profile.</p>
                </div>
                <div class="flow-ctrls-div">
                    <a href="#" class="form-back-link w-inline-block hide-back-mobile" @click.prevent="GoBack()">
                        <div class="text-block-1719">&lt;-</div>
                        <div class="text-block-1718">Back</div>
                    </a>
                    <a href="#" class="button-167-copy w-button" @click.prevent="advanceStep">Continue <span class="text-span-398">-&gt;</span></a>
                </div>
            </div>

            <div class="quizquestiondiv2-copy ad" v-if="active_el === 6">
                <div class="quizquestionheader-cop">Lose up to 31% <br>with RxPros™</div>
                <p class="paragraph-208 center">Our program combines medical evaluation, prescription treatment, and ongoing clinical guidance into a single, coordinated approach</p>
                <div class="quiz-img-div ad flow"><img sizes="100vw" srcset="@/assets/images/drop-weight-comprasion-quiz-p-500.png 500w, @/assets/images/drop-weight-comprasion-quiz-p-800.png 800w, @/assets/images/drop-weight-comprasion-quiz-p-1080.png 1080w, @/assets/images/drop-weight-comprasion-quiz-p-1600.png 1600w, @/assets/images/drop-weight-comprasion-quiz-p-2000.png 2000w, @/assets/images/drop-weight-comprasion-quiz.png 2560w" alt="" src="@/assets/images/drop-weight-comprasion-quiz.png" loading="lazy" class="image-694 flow outline"></div>
                <div class="flow-ctrls-div">
                    <a href="#" class="form-back-link w-inline-block hide-back-mobile" @click.prevent="GoBack()">
                        <div class="text-block-1719">&lt;-</div>
                        <div class="text-block-1718">Back</div>
                    </a>
                    <a href="#" class="button-167-copy w-button" @click.prevent="advanceStep">Continue <span class="text-span-398">-&gt;</span></a>
                </div>
            </div>

            <div class="quizquestiondiv2-copy ad" v-if="active_el === 7">
                <div class="quizquestionheader-cop">Care Designed to <br>Be Simple and Consistent</div>
                <p class="paragraph-208 center">Medical review, prescription management, and refills are handled through one coordinated system</p>
                <div class="quiz-img-div ad flow"><img sizes="100vw" srcset="@/assets/images/fast-easy-quiz-p-500.png 500w, @/assets/images/fast-easy-quiz-p-800.png 800w, @/assets/images/fast-easy-quiz-p-1080.png 1080w, @/assets/images/fast-easy-quiz-p-1600.png 1600w, @/assets/images/fast-easy-quiz-p-2000.png 2000w, @/assets/images/fast-easy-quiz.png 2560w" alt="" src="@/assets/images/fast-easy-quiz.png" loading="lazy" class="image-694 flow outline"></div>
                <div class="flow-ctrls-div">
                    <a href="#" class="form-back-link w-inline-block hide-back-mobile" @click.prevent="GoBack()">
                        <div class="text-block-1719">&lt;-</div>
                        <div class="text-block-1718">Back</div>
                    </a>
                    <a href="#" class="button-167-copy w-button" @click.prevent="advanceStep">Continue <span class="text-span-398">-&gt;</span></a>
                </div>
            </div>

            <div class="quizquestiondiv2-copy ad" v-if="active_el === 8">
                <div class="quizquestionheader-cop">Built on Verified Pharmacy Standards</div>
                <p class="paragraph-208 center">Our process includes licensed pharmacy partners and ongoing quality verification as part of RxPros™ clinical operations</p>
                <div class="quiz-img-div ad flow"><img sizes="100vw" srcset="@/assets/images/lab-quiz-p-500.jpg 500w, @/assets/images/lab-quiz-p-800.jpg 800w, @/assets/images/lab-quiz-p-1080.jpg 1080w, @/assets/images/lab-quiz-p-1600.jpg 1600w, @/assets/images/lab-quiz-p-2000.jpg 2000w, @/assets/images/lab-quiz.jpg 2560w" alt="" src="@/assets/images/lab-quiz.jpg" loading="lazy" class="image-694 flow outline">
                    <p class="paragraph-208 center subparag"><em class="italic-text">Medication sourcing and quality review processes follow established pharmacy and clinical standards</em></p>
                </div>
                <a href="#" class="button-167-copy w-button" @click.prevent="advanceStep">Continue <span class="text-span-398">-&gt;</span></a>
                <div class="trust-pilot-div"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66c5b5a28dcf34e92368a09f_icon_stars.svg" alt="" class="image-689">
                    <div class="flow-rating-div">
                        <div class="text-block-1723">Excellent</div>
                        <div class="text-block-1724">4.6 out of 5</div><img sizes="100vw" alt="" src="" loading="lazy" class="image-690">
                    </div>
                    <div>Join 100,000+ weight loss patients</div>
                </div>
            </div>

            <div class="step_forminfo_div large" v-if="active_el === 9">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Medical Safety Review</div>
                    <div class="text-block-1686">The treatment offered through RxPros™ is not appropriate for people with certain medical conditions. <br>If any of the following apply to you, this treatment may not be safe or appropriate for you.<br></div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d0869fe0c">
                            <div class="div-block-2267">
                                <ul role="list" class="list-18">
                                    <li class="list-item-19">Pregnancy, possible pregnancy, trying to conceive, or breastfeeding</li>
                                    <li class="list-item-19">End-stage kidney disease or dialysis</li>
                                    <li class="list-item-19">End-stage liver disease (cirrhosis)</li>
                                    <li class="list-item-19">Active cancer diagnosis or ongoing cancer treatment</li>
                                    <li class="list-item-19">Current or past eating disorders (including anorexia or bulimia)</li>
                                    <li class="list-item-19">Current suicidal thoughts or a history of suicide attempts</li>
                                    <li class="list-item-19">History of organ transplant or use of anti-rejection medications</li>
                                    <li class="list-item-19">Severe gastrointestinal conditions (such as gastroparesis or inflammatory bowel disease)</li>
                                    <li class="list-item-19">Uncontrolled substance use disorder, including opioids or alcohol</li>
                                    <li class="list-item-19">Personal or family history of medullary thyroid cancer or MEN 2</li>
                                    <li class="list-item-19">Diabetes requiring insulin, poorly controlled diabetes (A1c &gt;10%), or Type 1 diabetes</li>
                                    <li class="list-item-19">Diabetic eye disease, vision loss, or optic nerve damage</li>
                                    <li class="list-item-19">Use of blood thinners such as warfarin</li>
                                    <li class="list-item-19">History of pancreatitis</li>
                                    <li class="list-item-19">Use of street drugs or prescription medications without a valid prescription</li>
                                </ul>
                            </div>
                            <label class="w-checkbox checkoutflow_checkbox w-clearfix">
                                <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': people.healthConditions}"></div>
                                <input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" required style="opacity:0;position:absolute;z-index:-1" v-model="people.healthConditions"><span class="flow_checkbox-text w-form-label" for="checkbox-3">I confirm that none of the conditions above apply to me<br></span>
                            </label>
                            <div class="text-block-1720"><em class="italic-text-2">To continue, please confirm that none of the conditions above apply to you.</em></div>
                            <div class="flow-ctrls-div">
                                <a href="#" class="form-back-link w-inline-block hide-back-mobile" @click.prevent="GoBack()">
                                    <div class="text-block-1719">&lt;-</div>
                                    <div class="text-block-1718">Back</div>
                                </a>
                                <a href="#" class="continue-button step w-button" @click.prevent="handleSubmit">Continue <span class="text-span-426">-&gt;</span></a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step_forminfo_div" v-if="active_el === 10">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers line-break">Save Your Progress</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-info-form-div">
                    <div class="w-form">
                        <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d0869fe8f">
                            <div class="doc-bar-div">
                                <div class="div-block-2268"><img loading="lazy" src="@/assets/images/doc5-Photoroom.webp" alt="" class="image-687"></div>
                                <div class="div-block-2269">
                                    <div class="text-block-1721">This step helps us securely save your answers and guide next steps in your care.</div>
                                </div>
                            </div>
                            <div class="flow-form-full-div">
                                <div class="form-field-label">First name*</div><input class="checkout-flow-input w-input" maxlength="256" name="first-name" data-name="first name" placeholder="Your first name" type="text" id="first-name" required v-model="people.first_name" :class="{ 'field-error': fieldErrors.first_name }">
                            </div>
                            <div class="flow-form-full-div">
                                <div class="form-field-label">Last name*</div><input class="checkout-flow-input w-input" maxlength="256" name="last-name" data-name="last name" placeholder="Your last name" type="text" id="last-name" required v-model="people.last_name" :class="{ 'field-error': fieldErrors.last_name }">
                            </div>
                            <div class="flow-form-full-div">
                                <div class="form-field-label">Email*</div><input class="checkout-flow-input w-input" maxlength="256" name="email" data-name="email" placeholder="Email address" type="email" id="email" required v-model="people.email" @blur="checkEmailOnBlur" :class="{ 'field-error': fieldErrors.email, 'email-error': emailCheckError }">
                                <p class="paragraph-218">We&#x27;ll use your email to save your progress and share updates related to your medical review. You can unsubscribe at any time</p>
                            </div>
                            <div class="form-field-label">Phone Number</div><input class="checkout-flow-input w-input" maxlength="17" name="num-field" placeholder="(XXX) XXX-XXXX" type="text" id="num-field" pattern="[0-9]*" required autocomplete="off" inputmode="tel" :value="people.phone" @input="handlePhoneInput" @keypress="numericOnly" :class="{ 'field-error': fieldErrors.phone }">
                            <div class="form-small-header">Your phone number is used only for delivery updates and essential care-related messages.</div>
                            <label class="w-checkbox sms-consent-checkbox" :class="{ 'field-error': formErrors.emailConsent, 'is-shaking': shakeConsent }" @animationend="shakeConsent = false">
                                <input type="checkbox" v-model="people.agreed_to_email" name="checkbox-sms" id="checkbox-sms" data-name="Checkbox SMS" class="w-checkbox-input">
                                <span class="sms-consent-label w-form-label" for="checkbox-sms">By checking the box, you agree that RXPros can contact you at the telephone number provided using an autodialer, AI technology, artificial voice and prerecorded calls or text/SMS messages with information and offers. Msg. and data rates apply. You also agree to our <a href="https://www.rxpros.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://www.rxpros.com/terms" target="_blank">Terms</a>.</span>
                            </label>
                            <div v-if="formErrors.emailConsent" class="error-message">{{ formErrors.emailConsent }}</div>
                            <div v-if="formErrors.email" class="error-message">{{ formErrors.email }}</div>
                            <div v-if="showErrorPopup" class="error-message">{{ errorMessage }}</div>

                            <div class="flow-ctrls-div">
                                <a href="#" class="form-back-link w-inline-block" @click.prevent="GoBack()">
                                    <div class="text-block-1719">&lt;-</div>
                                    <div class="text-block-1718">Back</div>
                                </a>
                                <a href="#" class="continue-button step w-button" :class="{ 'disabled-btn': checkingEmail }" @click.prevent="!checkingEmail && handleSubmit()">{{ checkingEmail ? 'Please wait...' : 'Continue' }} <span class="text-span-426">-&gt;</span></a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step2_div" v-if="active_el === 11">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Are you already on GLP-1 medication?</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step2-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d0869ffcd">
                            <div class="flow_choicesdiv">
                                <label class="w-checkbox flow_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': isTakingGLP1 === true}" @click.prevent="handleGLP1Selection(true)">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2 hidden-radio" :class="{'w--redirected-checked': isTakingGLP1 === true}"></div><input type="radio" name="checkbox-glp1-11" id="checkbox-glp1-yes-11" data-name="Checkbox GLP1 Yes" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="checkbox-glp1-yes-11"><strong>Yes</strong>, I&#x27;m currently taking GLP-1 medication<br></span>
                                </label>
                                <label class="w-checkbox flow_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': isTakingGLP1 === false}" @click.prevent="handleGLP1Selection(false)">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2 hidden-radio" :class="{'w--redirected-checked': isTakingGLP1 === false}"></div><input type="radio" name="checkbox-glp1-11" id="checkbox-glp1-no-11" data-name="Checkbox GLP1 No" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="checkbox-glp1-no-11"><strong>No</strong>, but I would like to start<br></span>
                                </label></div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div style="height:180px"></div>
            </div>

            <div class="step2_div" v-if="active_el === 12">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Which medication are you taking?</div>
                    <div class="text-block-1686">Select the weight loss medication you&#x27;re currently using.</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step2-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get">
                            <div class="flow_choicesdiv">
                                <label class="w-checkbox flow_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : currentMedicationType === 'semaglutide'}" @click.prevent="handleCurrentMedicationSelection('semaglutide')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2 hidden-radio" :class="{'w--redirected-checked' : currentMedicationType === 'semaglutide'}"></div><input type="radio" name="checkbox-med" id="checkbox-sema" data-name="Checkbox Semaglutide" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="checkbox-sema">Semaglutide Compound<br></span>
                                </label>
                                <label class="w-checkbox flow_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : currentMedicationType === 'tirzepatide'}" @click.prevent="handleCurrentMedicationSelection('tirzepatide')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2 hidden-radio" :class="{'w--redirected-checked' : currentMedicationType === 'tirzepatide'}"></div><input type="radio" name="checkbox-med" id="checkbox-tirz" data-name="Checkbox Tirzepatide" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="checkbox-tirz">Tirzepatide Compound<br></span>
                                </label>
                                <label class="w-checkbox flow_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : currentMedicationType === 'mounjaro'}" @click.prevent="handleCurrentMedicationSelection('mounjaro')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2 hidden-radio" :class="{'w--redirected-checked' : currentMedicationType === 'mounjaro'}"></div><input type="radio" name="checkbox-med" id="checkbox-moun" data-name="Checkbox Mounjaro" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="checkbox-moun">Mounjaro<br></span>
                                </label>
                                <label class="w-checkbox flow_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : currentMedicationType === 'ozempic'}" @click.prevent="handleCurrentMedicationSelection('ozempic')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2 hidden-radio" :class="{'w--redirected-checked' : currentMedicationType === 'ozempic'}"></div><input type="radio" name="checkbox-med" id="checkbox-ozem" data-name="Checkbox Ozempic" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="checkbox-ozem">Ozempic<br></span>
                                </label>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step3_div" v-if="active_el === 13">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Got it - what dosage are you on?</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step3-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d0869fff0">
                            <div class="flow_choicesdiv">
                                <div class="medq_choicesdiv">
                                    <!-- Semaglutide dosages (for Semaglutide and Ozempic) -->
                                    <template v-if="currentMedicationType === 'semaglutide' || currentMedicationType === 'ozempic'">
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '0.25 mg'}" @click.prevent="selectDosage('semaglutide', '0.25 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '0.25 mg'}"></div><input type="radio" name="dosage" id="dosage-sema-025" data-name="Dosage Sema 0.25" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-sema-025">Semaglutide <strong>0.25 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '0.5 mg'}" @click.prevent="selectDosage('semaglutide', '0.5 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '0.5 mg'}"></div><input type="radio" name="dosage" id="dosage-sema-05" data-name="Dosage Sema 0.5" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-sema-05">Semaglutide <strong>0.5 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '1.0 mg'}" @click.prevent="selectDosage('semaglutide', '1.0 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '1.0 mg'}"></div><input type="radio" name="dosage" id="dosage-sema-10" data-name="Dosage Sema 1.0" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-sema-10">Semaglutide <strong>1.0 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '2.0 mg'}" @click.prevent="selectDosage('semaglutide', '2.0 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '2.0 mg'}"></div><input type="radio" name="dosage" id="dosage-sema-20" data-name="Dosage Sema 2.0" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-sema-20">Semaglutide <strong>2.0 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '2.5 mg'}" @click.prevent="selectDosage('semaglutide', '2.5 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '2.5 mg'}"></div><input type="radio" name="dosage" id="dosage-sema-25" data-name="Dosage Sema 2.5" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-sema-25">Semaglutide <strong>2.5 mg</strong><br></span>
                                        </label>
                                    </template>

                                    <!-- Tirzepatide dosages (for Tirzepatide and Mounjaro) -->
                                    <template v-if="currentMedicationType === 'tirzepatide' || currentMedicationType === 'mounjaro'">
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '2.5 mg'}" @click.prevent="selectDosage('tirzepatide', '2.5 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '2.5 mg'}"></div><input type="radio" name="dosage" id="dosage-tirz-25" data-name="Dosage Tirz 2.5" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-tirz-25">Tirzepatide <strong>2.5 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '5.0 mg'}" @click.prevent="selectDosage('tirzepatide', '5.0 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '5.0 mg'}"></div><input type="radio" name="dosage" id="dosage-tirz-50" data-name="Dosage Tirz 5.0" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-tirz-50">Tirzepatide <strong>5.0 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '7.5 mg'}" @click.prevent="selectDosage('tirzepatide', '7.5 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '7.5 mg'}"></div><input type="radio" name="dosage" id="dosage-tirz-75" data-name="Dosage Tirz 7.5" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-tirz-75">Tirzepatide <strong>7.5 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '10 mg'}" @click.prevent="selectDosage('tirzepatide', '10 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '10 mg'}"></div><input type="radio" name="dosage" id="dosage-tirz-100" data-name="Dosage Tirz 10" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-tirz-100">Tirzepatide <strong>10 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '12.5 mg'}" @click.prevent="selectDosage('tirzepatide', '12.5 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '12.5 mg'}"></div><input type="radio" name="dosage" id="dosage-tirz-125" data-name="Dosage Tirz 12.5" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-tirz-125">Tirzepatide <strong>12.5 mg</strong><br></span>
                                        </label>
                                        <label class="w-checkbox medq_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected': selectedDosage === '15 mg'}" @click.prevent="selectDosage('tirzepatide', '15 mg')">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox-2" :class="{'w--redirected-checked': selectedDosage === '15 mg'}"></div><input type="radio" name="dosage" id="dosage-tirz-150" data-name="Dosage Tirz 15" style="opacity:0;position:absolute;z-index:-1"><span class="flow_checkbox-text w-form-label" for="dosage-tirz-150">Tirzepatide <strong>15 mg</strong><br></span>
                                        </label>
                                    </template>
                                </div>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="step_chooserx_div" v-if="active_el === 14">
                <!-- Loading Overlay -->
                <div v-if="isLoading" class="loading-overlay2">
                    <div class="">
                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Choose your Treatment</div>
                    <div class="text-block-1686">Your provider will review your treatment plan before anything is finalized</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step-choiceflex-div">
                    <div class="flow-step1-choice" style="position: relative;">
                        <img src="/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                        <div class="flow-choice-img-div tirz"><img sizes="(max-width: 991px) 100vw, 941.9849243164062px" srcset="@/assets/images/tirz.jpg 500w, @/assets/images/tirz.jpg 800w, @/assets/images/tirz.jpg 942w" alt="" src="@/assets/images/tirz.jpg" loading="lazy" class="image-680 rx">
                            <div class="choice-pricetag">
                                <div class="pricetag-div">
                                    <div class="text-block-1699">From ${{ priceDollars(lowestMonthlyFor('tirzepatide')) }}<span class="text-span-415"><sup class="superscript-7">{{ priceCents(lowestMonthlyFor('tirzepatide')) }}</sup></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-step1-choice-info">
                            <div class="choice-info-flex">
                                <div class="info-flex-text">
                                    <div class="choice-productname">Tirzepatide<span class="text-span-428">+</span></div>
                                    <div class="choice-productsub">COMPOUNDED W/ B6</div>
                                </div>
                                <button class="choice-button w-button" @click.prevent="selectMedication('tirzepatide')" :disabled="isLoading">
                                    <span v-if="isLoading && selectedMedication === 'tirzepatide'">
                                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                            <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                            </circle>
                                        </svg>
                                    </span>
                                    <span v-else>Select</span>
                                </button>
                            </div>
                            <p class="paragraph-126 form">Most Effective - Works on 2 GLP receptors. Up to 31% weight loss.</p>
                        </div>
                    </div>
                    <div class="flow-step1-choice" style="position: relative;">
                        <img src="/images/klarna-badge.webp" alt="Klarna" class="klarna-badge-flow">
                        <div class="flow-choice-img-div sema"><img sizes="(max-width: 991px) 100vw, 941.9849243164062px" srcset="@/assets/images/sema.jpg 500w, @/assets/images/sema.jpg 800w, @/assets/images/sema.jpg 942w" alt="" src="@/assets/images/sema.jpg" loading="lazy" class="image-680 rx">
                            <div class="choice-pricetag">
                                <div class="pricetag-div">
                                    <div class="text-block-1700">From ${{ priceDollars(lowestMonthlyFor('semaglutide')) }}<span class="text-span-415"><sup class="superscript-7">{{ priceCents(lowestMonthlyFor('semaglutide')) }}</sup></span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-step1-choice-info">
                            <div class="choice-info-flex">
                                <div class="info-flex-text">
                                    <div class="choice-productname">Semaglutide<span class="text-span-429">+</span></div>
                                    <div class="choice-productsub">COMPOUNDED W/ B12</div>
                                </div>
                                <button class="choice-button w-button" @click.prevent="selectMedication('semaglutide')" :disabled="isLoading">
                                    <span v-if="isLoading && selectedMedication === 'semaglutide'">
                                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                            <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                            </circle>
                                        </svg>
                                    </span>
                                    <span v-else>Select</span>
                                </button>
                            </div>
                            <p class="paragraph-126 form">Most Prescribed - Works on 1 GLP receptor. Up to 21% weight loss.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="glpquiz_div2 report-part" v-if="active_el === 15">
                <div class="question-div-3">
                    <div class="flow-step2-headers">
                        <div class="checkout-flow-headers">{{people.first_name}}, here’s a summary of your medical review</div>
                        <div class="div-block-2240 hide-flex">
                            <div class="text-block-1687">Not sure?</div>
                            <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                                <div class="text-block-1736">Talk with a Care Concierge</div>
                            </a>
                        </div>
                    </div>
                    <div class="report-wrap flow">
                        <div class="text-block-1746">Health Summary (Based on Your Answers)</div>
                        <div class="new-report-div">
                            <div class="div-block-2260">
                                <div class="div-block-2259">
                                    <div class="text-block-1731 checkout-form-field-txt">Age</div>
                                    <div class="text-block-1743 checkout-form-field-data">{{ calculatedAge }}</div>
                                </div>
                                <div class="div-block-2190">
                                    <div class="text-block-1731 checkout-form-field-txt">Body Mass Index (BMI)</div>
                                    <div class="text-block-1743 checkout-form-field-data">{{ bmi_calculated || '0.0' }}</div>
                                </div>
                                <div class="div-block-2259">
                                    <div class="text-block-1731 checkout-form-field-txt">Sex</div>
                                    <div class="text-block-1743 checkout-form-field-data">{{ people.gender || 'Not specified' }}</div>
                                </div>
                            </div>
                            <div class="div-block-2260">
                                <div class="div-block-2259 weight">
                                    <div class="text-block-1731 checkout-form-field-txt">Current Weight</div>
                                    <div class="text-block-1743 checkout-form-field-data">{{ people.weight || 0 }} lbs</div>
                                </div>
                                <div class="div-block-2259 weight goal">
                                    <div class="text-block-1731 report-box">Goal Weight</div>
                                    <div class="text-block-1743 weight report-box">{{ goalWeight }} lbs</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rx_div">
                        <div class="text-block-1615"><strong class="bold-text-45">Lose Weight with Science</strong></div>
                        <div class="text-block-1616"><strong class="bold-text-46">Preparing Your Treatment Plan</strong></div>
                        <p class="paragraph-219">This treatment plan is based on your health information and follows a structured, physician-guided approach to medical weight loss.</p>
                        <div class="div-block-2177">
                            <div class="div-block-2178">
                                <div class="div-block-2179">
                                    <div>
                                        <div class="text-block-1617">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                        <div class="text-block-1618">Subcutaneous Injection</div>
                                    </div>
                                    <a href="#" @click.prevent="active_el--" class="link-85"><strong>Request a change </strong><span class="text-span-401">-&gt;</span></a>
                                </div>
                                <div class="div-block-2180">
                                    <img  v-if="selectedMedication === 'semaglutide'" alt="" src="@/assets/images/checkout-sema.png" loading="lazy" class="image-656">
                                    <img  v-else alt="" src="@/assets/images/triz528.png" loading="lazy" class="image-656">
                                </div>
                            </div>
                            <div class="div-block-2181">
                                <div class="div-block-2182">
                                    <div class="div-block-2183">
                                        <div class="text-block-1619">+ Anti-Nausea</div>
                                    </div>
                                    <p class="paragraph-220">Provided when clinically appropriate <strong>at no additional cost</strong>.</p>
                                </div>
                                <div class="div-block-2184"><img loading="lazy" src="@/assets/images/checkout-nausea.png" alt="" class="image-657"></div>
                            </div>
                        </div>
                        <div class="div-block-2185">
                            <div class="div-block-2186"><img loading="lazy" src="@/assets/images/emoji_thumb_1emoji_thumb.webp" alt=""></div>
                            <p class="paragraph-221">Don’t worry, you can still change your medication after your clinician call.</p>
                        </div>
                    </div>
                    <div class="button-div-bottom">
                        <a href="#" class="button-167 flow w-button" @click.prevent="advanceStep">CHECKOUT <span class="text-span-398">-&gt;</span></a>
                        <p class="paragraph-205">Compounded medications offered through this service are prescribed on an individual basis by licensed healthcare providers. While some patients may experience weight loss or other benefits, results are not guaranteed. Outcomes depend on a variety of factors including, but not limited to, patient health status, genetics, lifestyle, diet, and exercise. Neither the prescribing provider nor the pharmacy makes any promise or warranty of specific results. Published research, including studies in the New England Journal of Medicine, has reported average weight loss of approximately 22% with semaglutide and 16% with tirzepatide in clinical trial populations. These results reflect averages in controlled settings and may not represent individual patient experience.</p>
                    </div>
                </div>
            </div>

            <div class="step4_div" v-if="active_el === 16">
                <div class="inclusions-new">
                    <div class="flow-inclusions-header">The Lowest Price on the Internet. Everything Included.</div>
                    <div class="text-block-1713">One flat price covers everything - your providers visit, medication, overnight shipping, and ongoing care. No membership fees. No price increases. Ever.</div>
                    <div class="text-block-1705">What&#x27;s included:</div>
                    <div class="flow_inclusions-div">
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div">
                                    <img v-if="selectedMedication === 'semaglutide'" loading="lazy" src="@/assets/images/included1.png" alt="">
                                    <img v-else loading="lazy" src="@/assets/images/triz168.png" alt="">
                                </div>
                                <div class="inclusions-text-div product">
                                    <div class="text-block-1706">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}+</div>
                                    <p class="inclusions-subs">GLP-1 medications compounded with {{ selectedMedication === 'semaglutide' ? 'B12' : 'B6' }} for {{ selectedMedication === 'semaglutide' ? 'energy' : 'metabolism' }}</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div">
                                <div class="div-block-2249">
                                    <div class="text-block-1710">$399</div>
                                    <div class="text-block-1711-copy">${{ priceDollars(getFirstMonthPrice()) }}<span><sup class="superscript-11">{{ priceCents(getFirstMonthPrice()) }}</sup></span><span class="text-span-420">/month</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img loading="lazy" src="@/assets/images/included2.png" alt="" class="image-681"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Doctor Review &amp; Prescription</div>
                                    <p class="inclusions-subs">US-licensed physician reviews your info and prescribes if appropriate</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div check-with-icon">
                                <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img loading="lazy" src="@/assets/images/included3.png" alt="" class="image-682"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Discounted Peptide Therapies</div>
                                    <p class="inclusions-subs">Access to 15+ peptide therapies at discounted pricing</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div check-with-icon">
                                <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div bottom"><img loading="lazy" src="@/assets/images/included4.png" alt="" class="image-684 widen"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Metabolic Weight Plan</div>
                                    <p class="inclusions-subs">Personalized guidance to help you lose weight and keep it off</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div check-with-icon">
                                <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div"><img loading="lazy" src="@/assets/images/included6.png" alt="" class="image-683"></div>
                                <div class="inclusions-text-div">
                                    <div class="text-block-1706">Overnight Cold Shipping</div>
                                    <p class="inclusions-subs">Cold-packed overnight shipping keeps your prescription effective.</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div check-with-icon">
                                <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                            </div>
                        </div>
                        <div class="flow-inclusion-entry-div">
                            <div class="inclusions-left-div">
                                <div class="inclusion-img-div widen"><img src="@/assets/images/included5.png" loading="lazy" alt="" class="image-698"></div>
                                <div class="inclusions-text-div long">
                                    <div class="text-block-1706">Doctor Support &amp; Monitoring</div>
                                    <p class="inclusions-subs">24/7 medical support - our team is just a text away</p>
                                </div>
                            </div>
                            <div class="inclusions-right-div check-with-icon">
                                <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                            </div>
                        </div>
                    </div>
                    <div class="format-divider"></div>
                    <div class="div-block-2248 total">
                        <div class="text-block-1712">Total</div>
                        <div class="div-block-2249">
                            <div class="div-block-2250"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/675086d9d8caa3eea848a870_icon_tag.svg" alt="" class="image-688">
                                <div class="text-block-1722">Holiday Deal</div>
                            </div>
                            <div class="text-block-1710">$399</div>
                            <div class="text-block-1711">${{ priceDollars(getFirstMonthPrice()) }}<span><sup class="superscript-11">{{ priceCents(getFirstMonthPrice()) }}</sup></span><span class="text-span-420">/month</span></div>
                        </div>
                    </div>
                    <div class="trust-pilot-div"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66c5b5a28dcf34e92368a09f_icon_stars.svg" alt="" class="image-689">
                        <div class="flow-rating-div">
                            <div class="text-block-1723">Excellent</div>
                            <div class="text-block-1724">4.6 out of 5</div><img sizes="100vw" alt="" src="" loading="lazy" class="image-690">
                        </div>
                        <div class="text-block-1747">Trusted by thousands of members</div>
                    </div>
                    <div class="flow-ctrls-div">
                        <a href="#" @click.prevent="active_el--"  class="form-back-link w-inline-block">
                            <div class="text-block-1719">&lt;-</div>
                            <div class="text-block-1718">Back</div>
                        </a>
                        <!-- advanceStep, not active_el++: at this step the two do the
                             same thing except advanceStep also reports the plan the
                             picker is about to open on. A bare increment left every
                             patient who accepts the default with no choose_plan. -->
                        <a href="#" @click.prevent="advanceStep" class="continue-button step w-button">Continue <span class="text-span-426">-&gt;</span></a>
                    </div>
                </div>
            </div>

            <div class="step5_div" v-if="active_el === 17">
                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Complete your order</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step5-choiceflex-div">
                    <div class="flow-payplan-div">
                        <div class="checkout-form w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d086a00db">
                                <div class="flow_payplan_select">
                                    <div class="pay-plan-top">
                                        <div class="text-block-1688">Weight Loss</div>
                                    </div>
                                    <div class="order-item-flex">
                                        <div class="div-block-2241">
                                            <div class="product-box-flex">
                                                <div class="product-name-and-sub">
                                                    <div class="text-block-1690">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}<span class="text-span-422">+</span></div>
                                                    <div class="text-block-1691">COMPOUNDED W/ {{ selectedMedication === 'semaglutide' ? 'B12' : 'B6' }}</div>
                                                </div>

                                                <div v-if="nextThreeMonthDoses" class="checkout-dosage-div">
                                                    <div class="checkout---month-dose" v-for="monthDose in nextThreeMonthDoses" :key="monthDose.month">
                                                        <div class="text-block-1715">MONTH {{ monthDose.month }}</div>
                                                        <div class="text-block-1717">{{ monthDose.dose }} <span class="text-span-421">MG</span></div>
                                                        <div class="text-block-1715">Weekly Dose</div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="text-block-1693">Meet with a provider to discuss your personalized care plan.</div>
                                        </div>
                                        <div class="order_img_div">
                                            <img  v-if="selectedMedication === 'semaglutide'" sizes="(max-width: 767px) 100vw, 527.9948120117188px" srcset="@/assets/images/checkout-sema-p-500.png 500w, @/assets/images/checkout-sema.png 528w" alt="" src="@/assets/images/checkout-sema.png" loading="lazy">
                                            <img v-else sizes="(max-width: 767px) 100vw, 527.9948120117188px" srcset="@/assets/images/triz500.png 500w, @/assets/images/triz528.png 528w" alt="" src="@/assets/images/triz528.png" loading="lazy">
                                        </div>
                                    </div>
                                    <div class="text-block-1696"><strong>We always send a 3-month supply</strong> - no refill hassle. Buy Now, Pay Later plans are available from Klarna, allowing you to pay monthly with no interest and no credit check.</div>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===1}" @click="changePaymentTerms(1)">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===1}"></div>
                                        <input type="radio" v-model="paymentInfo.payment_terms" :value="1" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                        <span class="checkout-checkbox-text w-form-label">
                                            <strong>${{ Math.floor(getFirstMonthPrice()) }}</strong>
                                            <span class="text-span-416"><strong><sup>{{ (getFirstMonthPrice() % 1).toFixed(2).split('.')[1] }}</sup></strong></span>
                                            <span class="text-span-417">/mo <br> <span class="tosspan">*3 month supply paid monthly. No credit checks or financing charges.</span></span>
                                        </span>
                                        <div class="div-block-2242">
                                            <div class="text-block-1694">Recurring</div>
                                        </div>
                                    </label>

                                    <div class="text-block-1697">Save big when paid quarterly</div>
                                    <div class="plans-div-2">

                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===3}" @click="changePaymentTerms(3)">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===3}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="3" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <strong>${{ Math.floor(getTotalPrice(3) / 3) }}</strong>
                                                <span class="text-span-416"><strong><sup>{{ ((getTotalPrice(3) / 3) % 1).toFixed(2).split('.')[1] }}</sup></strong></span>
                                                <span class="text-span-417">/ mo. (3 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694">${{ getTotalPrice(3).toFixed(2) }} today</div>
                                            </div>
                                        </label>

                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===6}" @click="changePaymentTerms(6)">
                                            <span class="plan-badge plan-badge--popular">Popular</span>
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===6}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="6" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <strong>${{ Math.floor(getTotalPrice(6) / 6) }}</strong>
                                                <span class="text-span-416"><strong><sup>{{ ((getTotalPrice(6) / 6) % 1).toFixed(2).split('.')[1] }}</sup></strong></span>
                                                <span class="text-span-417">/ mo. (6 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694">${{ getTotalPrice(6).toFixed(2) }} today</div>
                                            </div>
                                        </label>

                                        <label class="w-checkbox checkout_checkbox-field _12mo w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===12}" @click="changePaymentTerms(12)">
                                            <span class="plan-badge plan-badge--recommended">Recommended</span>
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===12}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="12" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <strong>${{ Math.floor(getTotalPrice(12) / 12) }}</strong>
                                                <span class="text-span-416"><strong><sup>{{ ((getTotalPrice(12) / 12) % 1).toFixed(2).split('.')[1] }}</sup></strong></span>
                                                <span class="text-span-417">/ mo. (12 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694">${{ getTotalPrice(12).toFixed(2) }} today</div>
                                                <span class="huge-savings-btn">Huge Savings</span>
                                            </div>
                                        </label>

                                    </div>
                                </div>
                            </form>

                        </div>
                        <div class="flow-ctrls-div" style="justify-content: center;width: 100%;display:flex;">
                            <a href="#" class="continue-button step w-button" style="width: 100%;" @click.prevent="continueFromStep17">Continue <span class="text-span-423">-&gt;</span></a>
                        </div>
                    </div>
                    <div class="flow-pay-summary">
                        <div class="checkout-form w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d086a0160">
                                <div class="flow-sum-maindiv">
                                    <div class="flow-summary-top">
                                        <div class="text-block-1688-copy">Order Summary</div>
                                    </div>
                                    <div class="flow-sum-orders-div">
                                        <div class="order-line-div">
                                            <div class="order-name">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                            <div class="div-block-2243">
                                                <div class="order-price">${{ Math.floor(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup> </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order-total-div">
                                        <div class="text-block-1698">Due today</div>
                                        <div class="div-block-2243">
                                            <div class="order-price-total">${{ Math.floor(getTotalOrderAmount()) }}<sup class="superscript-9-copy">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup> </div>
                                        </div>
                                    </div>
                                    <div class="flow-sum-guarantee-div">
                                        <p class="paragraph-217"><strong>Our guarantee:</strong> If you pay for a treatment and your provider determines you&#x27;re not eligible, we&#x27;ll issue a full refund</p>
                                    </div>
                                </div>
                            </form>

                        </div>

                    </div>
                </div>
            </div>
            <div class="step6_div" v-if="active_el === 18">
                <div class="flow-step2-headers">
                    <div class="checkout-flow-headers">Checkout</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-113 hide w-inline-block"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66eaeeda40cb77c641b0c916_icon_call.svg" alt="" class="image-697">
                            <div class="text-block-1736">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step3-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="69396781117ab182f1cc1250" data-wf-element-id="17ce2ecb-939a-5461-9c35-d41d086a0192">
                            <div class="flow-payment-div">
                                <div class="flow-sum-maindiv">
                                    <div class="flow-summary-top">
                                        <div class="text-block-1688-copy">Order Summary</div>
                                    </div>
                                    <div class="flow-sum-orders-div">
                                        <div class="order-line-div">
                                            <div class="order-name">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                            <div class="div-block-2243">
                                                <div class="order-price">${{ Math.floor(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup> </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order-total-div">
                                        <div class="text-block-1698">Due today</div>
                                        <div class="div-block-2243">
                                            <div class="order-price-total">${{ Math.floor(displayTotal) }}<sup class="superscript-9-copy">{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup> </div>
                                        </div>
                                    </div>
                                    <div class="text-block-1705">What&#x27;s included</div>
                                    <div class="inclusions-new">
                                        <div class="flow_inclusions-div">
                                            <div class="flow-inclusion-entry-div">
                                                <div class="inclusions-left-div">
                                                    <div class="inclusion-img-div widen"><img src="@/assets/images/included5.png" loading="lazy" alt="" class="image-698"></div>
                                                    <div class="inclusions-text-div long">
                                                        <div class="text-block-1706">Doctor Support &amp; Monitoring</div>
                                                        <p class="inclusions-subs">24/7 medical support - our team is just a text away</p>
                                                    </div>
                                                </div>
                                                <div class="inclusions-right-div check-with-icon">
                                                    <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                                                </div>
                                            </div>
                                            <div class="flow-inclusion-entry-div">
                                                <div class="inclusions-left-div">
                                                    <div class="inclusion-img-div bottom"><img loading="lazy" src="@/assets/images/included4.png" alt="" class="image-684 widen"></div>
                                                    <div class="inclusions-text-div">
                                                        <div class="text-block-1706">Metabolic Weight Plan</div>
                                                        <p class="inclusions-subs">Personalized guidance to help you lose weight and keep it off</p>
                                                    </div>
                                                </div>
                                                <div class="inclusions-right-div check-with-icon">
                                                    <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                                                </div>
                                            </div>
                                            <div class="flow-inclusion-entry-div">
                                                <div class="inclusions-left-div">
                                                    <div class="inclusion-img-div"><img loading="lazy" src="@/assets/images/included2.png" alt="" class="image-681"></div>
                                                    <div class="inclusions-text-div">
                                                        <div class="text-block-1706">Doctor Review &amp; Prescription</div>
                                                        <p class="inclusions-subs">US-licensed physician reviews your info and prescribes if appropriate</p>
                                                    </div>
                                                </div>
                                                <div class="inclusions-right-div check-with-icon">
                                                    <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                                                </div>
                                            </div>
                                            <div class="flow-inclusion-entry-div">
                                                <div class="inclusions-left-div">
                                                    <div class="inclusion-img-div"><img loading="lazy" src="@/assets/images/included6.png" alt="" class="image-683"></div>
                                                    <div class="inclusions-text-div">
                                                        <div class="text-block-1706">Overnight Cold Shipping</div>
                                                        <p class="inclusions-subs">Cold-packed overnight shipping keeps your prescription effective.</p>
                                                    </div>
                                                </div>
                                                <div class="inclusions-right-div check-with-icon">
                                                    <div class="text-block-1708">Included</div><img src="@/assets/images/check-icon-round-green.png" loading="lazy" alt="" class="check-icon-img">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-field-label">Coupon Code</div>
                                <div class="div-block-2246">
                                    <input class="text-field-68 w-input" maxlength="256" :class="{'field-error' : couponError}" name="field" data-name="Field" v-model="paymentInfo.couponCode" placeholder="Optional Coupon Code" type="text" id="field" :disabled="couponApplied">
                                    <a href="#" @click.prevent="handleCouponSubmit" class="button-172 w-button" :class="{'disabled': couponApplied}">{{ couponApplied ? 'Applied' : 'Apply' }}</a>
                                </div>
                                <div class="text-block-1704">Payment details</div>
                                
                                
                                <!-- Express Checkout (Apple Pay / Google Pay / Klarna) -->
                                <div class="express-checkout-section">
                                    <div class="express-checkout-box" :class="{ 'single-option': !canMakeExpressCheckout }" v-show="canMakeExpressCheckout || paymentInfo.payment_terms !== 1">
                                        <div v-show="canMakeExpressCheckout" id="express-checkout-element"></div>
                                        <button v-show="paymentInfo.payment_terms !== 1" type="button" class="klarna-btn" :disabled="submitted" @click="payWithKlarna">
                                            <span class="klarna-btn-text">Buy now, pay later with</span>
                                            <img class="klarna-logo" src="@/assets/images/Klarna.png" alt="Klarna" />
                                        </button>
                                    </div>
                                    <div class="divider" v-show="canMakeExpressCheckout || paymentInfo.payment_terms !== 1">
                                        <div class="divider-line"></div>
                                        <span>OR</span>
                                        <div class="divider-line"></div>
                                    </div>
                                </div>
                                <!-- Credit Card Header -->
                                <div class="div-block-2103 new">
                                    <div class="text-block-1451"><strong class="bold-text-4">Credit Card</strong></div>
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103790_visa.png" class="image-585">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103780_mastercard.png" class="image-585">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd36103794_AmEx.png" class="image-585">
                                    <img width="35" loading="lazy" alt="" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/65ae6cf4027a5dcd3610377e_discover.png" class="image-585">
                                </div>
                                    <!-- Stripe Card Elements -->
                                    <div class="form-group">
                                        <label>Card number</label>
                                        <div id="card-number-element" class="ns-card-element"></div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group">
                                            <label>Expiration date</label>
                                            <div id="card-expiry-element" class="ns-card-element"></div>
                                        </div>
                                        <div class="form-group">
                                            <label>Security code</label>
                                            <div class="cvc-input-wrapper">
                                                <div id="card-cvc-element" class="ns-card-element"></div>
                                            </div>
                                        </div>
                                    </div>

                                <label class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>

                                <div :class="{ 'address-highlight': addressBlink }">
                                    <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" border-color="#dfdfdf" />
                                </div>

                                 <!-- <label class="w-checkbox checkbox-field-26" style="background-color: #fff; justify-content: left;padding-bottom:0px;">
                                    <input type="checkbox" name="checkbox-4" v-model="differentShipping" id="checkbox-4" data-name="Checkbox 4" class="w-checkbox-input checkbox-19">
                                    <span class="checkbox-label-28 w-form-label" for="checkbox-4">Different billing address?</span>
                                </label> -->

                                <!-- Billing Address (only if different) -->
                                <!-- <div v-if="differentShipping" class="address-section">
                                    <div class="form-field-label">Billing Address</div>
                                    <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressDataBilling" border-color="#dfdfdf" />
                                </div> -->

                                <!-- Checkout API Error Banner -->
                                <div v-if="checkoutErrorMessage" class="checkout-error-banner">
                                    <div class="checkout-error-banner-content">
                                        <span class="checkout-error-icon">&#9888;</span>
                                        <div class="checkout-error-text">
                                            <div class="checkout-error-heading">Payment failed</div>
                                            <div class="checkout-error-message">{{ checkoutErrorMessage }}</div>
                                            <div class="checkout-error-helper">Please check your card details and try again, or use a different payment method.</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Validation/tokenization error display -->
                                <div v-if="paymentError" class="w-form-fail" style="display:block; margin-top: 15px; margin-bottom: 15px;">
                                    <div>{{ errorMessage }}</div>
                                </div>

                                <div class="div-block-2247">
                                    <button type="button" @click.prevent="getStripeToken" :disabled="submitted" class="pay-button pay w-button">
                                        {{ submitted ? 'Processing...' : 'Pay' }}
                                    </button>

                                    <!-- Subscription agreement -->
                                    <div class="subscription-agreement">
                                        <p class="paragraph-185-copy">By enrolling, I acknowledge that I am signing up for a recurring subscription and authorize RXposed to charge my selected payment method at the applicable renewal rate until I cancel.</p>
                                        <p class="paragraph-185-copy">I may cancel my subscription at any time through my patient portal. To avoid future charges, I must cancel before my next scheduled renewal date.</p>
                                        <p class="paragraph-185-copy">More than 80% of our members continue GLP-1 therapy for longer than six months. RXposed is committed to supporting members throughout their treatment journey while offering some of the most competitive pricing available online.</p>
                                    </div>

                                    <p class="paragraph-185-copy">
                                        By clicking "Pay Now" you agree to enroll in a {{ paymentInfo.payment_terms }}-month program{{ paymentInfo.payment_terms > 1 ? ' billed upfront' : ' billed monthly' }}, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the
                                        <a href="https://rxpros.com/returns" target="_blank">Refund Policy</a>,
                                        <a href="https://rxpros.com/terms" target="_blank">Terms and Conditions</a>,
                                        <a href="https://rxpros.com/terms" target="_blank">Terms of Use</a>,
                                        <a href="https://rxpros.com/privacy" target="_blank">Privacy Policy</a>,
                                        <a href="https://rxpros.com/hipaa" target="_blank">HIPAA Notice</a>, and
                                        <a href="https://rxpros.com/telehealth" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                    </p>
                                </div>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Paid User Modal -->
    <div v-if="showPaidUserModal" class="modal-overlay" @click.self="showPaidUserModal = false">
        <div class="modal-content paid-user-modal">
            <button class="modal-close" @click="showPaidUserModal = false">&times;</button>
            <div class="modal-body">
                <h2 class="modal-title">Welcome back!</h2>
                <p v-if="modalMode === 'wrong_role'">This email is associated with a {{ modalRole }} account. Please log in to continue, or use a different email.</p>
                <p v-else>You already have an account with us. Log in to manage your treatment, track shipments, and message your care team.</p>
                <button class="modal-btn modal-btn-primary" @click="goToLogin">Log In</button>
                <button class="modal-btn modal-btn-secondary" @click="showPaidUserModal = false">Not me — use a different email</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js"
import { cleanUsPhone, formatUsPhoneInput, isValidUsPhone, syncPhoneInput } from "@/utils/phone"
let stripe = null;
let paymentElements = null;
let elements = null;

import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue'
import { checkEmail } from "@/utils/checkEmail"
import state from "@/utils/state.json"
import {
    mapActions,
    mapGetters
} from 'vuex'
import {
    getProductById
} from '@/utils/productData'
import FastTrackUpsellModal from '../checkouts/FastTrackUpsellModal.vue'
import { loadFastTrackAddon } from '@/utils/fastTrackUpsell'
import { fireOrderPurchase } from '@/utils/orderPurchaseTracking'
import { paymentMethodFromExpressType } from '@/utils/paymentMethod'
import { needsBankCheck, runBankChecks, shopperMessage } from '@/utils/bankCheck'
import { BLOCKED_STATE_MESSAGE, isBlockedState } from '@/utils/blockedStates'

// Shared across instances so a remount can't stack up requests. Keyed by product id
// because this page lets the customer switch medication, and each has its own plans —
// and the treatment picker prices both at once, so two can be in flight together.
let plansRequests = {};

// Same budgets checkoutWeightLoss uses — one dropped request on flaky mobile used to
// leave a page with no live plan for the whole session.
const PLANS_REQUEST_TIMEOUT_MS = 8000;   // per attempt
const PLANS_MAX_ATTEMPTS = 4;            // first try + 3 retries
const PLANS_RETRY_BACKOFF_MS = [1000, 2500, 5000];

// The longest a customer waits at the pay button while requirePlanId gives the
// in-flight plan load a last chance to land.
const PLANS_PAY_WAIT_MS = 6000;

export default {
    name: 'WeightLossCheckoutFlow',
    components: {
        GooglePlacesAutocomplete,
        FastTrackUpsellModal
    },
    props: ['baseUrl', 'googleMapsApiKey'],
    data() {
        return {
            supportPhone: process.env.VUE_APP_SUPPORT_PHONE || '(855) 495-3050',
            allState: state,
            active_el: 1,
            totalSteps: 18,
            formErrors: {},
            shakeConsent: false,
            fieldErrors: {},
            isSubmitting: false,
            checkingEmail: false,
            emailCheckError: false,
            showPaidUserModal: false,
            modalMode: 'paid',
            modalRole: '',
            showErrorPopup: false,
            errorMessage: '',
            summeryOpen: false,
            // Stripe Payment Element (used for express checkout only)
            paymentElement: null,
            paymentElementReady: false,
            hasCardInput: false,
            expressCheckoutElement: null,
            canMakeExpressCheckout: false,
            submitted: false,
            // Priority Physician Review. Resolved from the catalog while the customer
            // fills the form, then offered as a yes/no modal AFTER the order is
            // captured — it is a separate charge and touches no checkout payload.
            // null (product missing or inactive) means no offer is ever made.
            fastTrackAddon: null,
            fastTrackOfferOpen: false,
            // Where to go once the offer is answered: the redirect the order would
            // have made immediately if there were no offer to show.
            fastTrackPendingRoute: null,
            // Session id resolved for the order's charge, reused by the add-on charge so
            // both land on the same tracking session.
            trackingSessionId: '',
            paymentError: false,
            checkoutErrorMessage: '',
            toastMessage: '',
            addressBlink: false,
            differentShipping: false,
            selectedMedication: '',
            selectedDosage: '',
            previousMedication: null,
            previousDosage: null,
            couponError: false,
            couponValid: false,
            couponApplied: false,
            isTakingGLP1: null, // null = not answered, true = taking, false = not taking
            currentMedicationType: '', // Which medication they're currently taking (semaglutide, tirzepatide, mounjaro, ozempic)
            cartId: '',
            isLoading: false,

            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            billingAddress: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            // The plan id the last choose_plan reported. The picker can open before
            // the live plans land, and that first report carries the fallback price
            // and no plan id; this is what lets the real one replace it once.
            lastTrackedPlanId: null,
            paymentInfo: {
                // The plan the picker opens on, for both medications. 6 months, matching
                // the other two checkouts. A returning customer's saved progress still
                // restores whatever they picked.
                payment_terms: 6,
                user_id: '',
                cardToken: '',
                amount: 0,
                discount: 0,
                medication: '',
                couponCode: '',
                couponId: null,
                paymentMethod: null,
                cartItems: [],
                cardDetails: [],
                planId: '',
                // Card info from Stripe
                cardBin: '',
                cardLast4: '',
                cardBrand: '',
            },
            // Last-resort prices, used only until /api/get-all-plans answers and if it
            // never does. They mirror the live SALE plan records (isPromo) that this page
            // now sells, so a failed fetch can never charge more than the page advertised.
            // The API is the source of truth: a price change in the admin must NOT be
            // made here, and if the sale ends these have to be resynced.
            pricingConfig: JSON.parse('{"semaglutide":{"monthly":{"first":174.97,"regular":174.97},"terms":{"3":449.91,"6":749.82,"12":1079.64}},"tirzepatide":{"monthly":{"first":249.97,"regular":249.97},"terms":{"3":599.91,"6":1049.82,"12":1439.64}}}'),
            // Live plans for the selected medication, keyed by payment_terms:
            // { terms: { id, price } }. Empty until the fetch lands.
            apiPlans: {},
            // Every medication's plans, keyed by product id, so the treatment picker can
            // show each card's real price without waiting for it to be selected.
            plansByProduct: {},
            // Which product apiPlans belongs to, so switching medication refetches
            // instead of pricing the new one off the old one's plans.
            apiPlansProductId: '',
            paymentTermLabels: {
                1: {
                    planName: "Monthly Plan",
                    duration: "monthly",
                    billingFrequency: "monthly",
                    billingLabel: "Billed Monthly",
                    supplyDuration: "Monthly"
                },
                3: {
                    planName: "Quarterly Plan",
                    duration: "3-month",
                    billingFrequency: "quarterly",
                    billingLabel: "Billed Quarterly",
                    supplyDuration: "3 Month"
                },
                6: {
                    planName: "Half yearly Plan",
                    duration: "6-month",
                    billingFrequency: "every 6 months",
                    billingLabel: "Billed Every 6 Months",
                    supplyDuration: "6 Month"
                },
                12: {
                    planName: "yearly Plan",
                    duration: "12-month",
                    billingFrequency: "annually",
                    billingLabel: "Billed Annually",
                    supplyDuration: "12 Month"
                }
            },

            people: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                address: '',
                city: '',
                zip: '',
                apt: '',
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                desired_weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agreed_to_email: false,
                state: '',
                agreed_to_terms: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                user_agent: "",
                ip_address: '',
                tracking_session_id: '',
                age: '',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
                categories: {
                    weightLoss: false,
                    longevity: false,
                    mind: false,
                    wellness: false
                },
                healthConditions: false
            }
        }
    },
    async mounted() {
        // Load saved progress from session storage
        this.loadProgress();

        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();

        // Live prices and plan ids. Started here so they are in place long before the
        // payment step; every price falls back to pricingConfig until this lands.
        // Both medications, because the treatment picker shows a price on each card
        // before either has been selected.
        this.loadPlans('tirzepatide');
        this.loadPlans('semaglutide');

        // Resolved up front, never at success time: a customer who has just paid must
        // not wait on a catalog request before being sent to their confirmation.
        loadFastTrackAddon(this.baseUrl).then((resolved) => { this.fastTrackAddon = resolved; });

        window.addEventListener('pageshow', this.handlePageShow);

        // If user refreshes on step 18 (payment page), initialize Stripe and card elements
        if (this.active_el === 18) {
            this.$nextTick(async () => {
                await this.initStripe();
                this.createCardElement();
                this.createExpressCheckout();
            });
        }
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.handlePageShow);
    },
    computed: {
        ...mapGetters(['user', 'isAuthenticated', 'cartItems', 'cartTotal', 'cartTotalNoDiscount']),

        supportPhoneTel() {
            const digits = this.supportPhone.replace(/\D/g, '');
            return `tel:+1${digits}`;
        },

        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },

        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },

        bmi_calculated() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches);
            const weightInPounds = parseInt(this.people.weight);
            if (heightInInches && weightInPounds) {
                return ((weightInPounds * 703) / (heightInInches * heightInInches)).toFixed(2);
            }
            return "";
        },

        calculatedAge() {
            if (!this.people.dob.yyyy || !this.people.dob.mm || !this.people.dob.dd) {
                return 'Not specified';
            }
            const birthDate = new Date(
                parseInt(this.people.dob.yyyy),
                parseInt(this.people.dob.mm) - 1,
                parseInt(this.people.dob.dd)
            );
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },

        goalWeight() {
            const currentWeight = parseInt(this.people.weight) || 0;
            if (currentWeight === 0) {
                return 0;
            }
            // Goal weight is 22% less than current weight
            const weightLoss = currentWeight * 0.22;
            return Math.round(currentWeight - weightLoss);
        },

        // Payment-related computed properties
        amountInCents() {
            return Math.round(this.getTotalOrderAmount() * 100);
        },

        // What the customer sees as their total.
        displayTotal() {
            return parseFloat(this.getTotalOrderAmount().toFixed(2));
        },

        // Prices for the selected medication: the live plan records, per term, with the
        // hardcoded config standing in for anything the API hasn't given us. Every price
        // shown on this page and the amount charged both read through here, so display
        // and charge cannot diverge.
        activePricing() {
            const fallback = this.selectedMedication === 'semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;

            const live = this.apiPlans || {};
            if (Object.keys(live).length === 0) return fallback;

            const monthly = live[1] ? live[1].price : null;
            return {
                monthly: {
                    first: monthly != null ? monthly : fallback.monthly.first,
                    regular: monthly != null ? monthly : fallback.monthly.regular,
                },
                terms: {
                    3: live[3] ? live[3].price : fallback.terms[3],
                    6: live[6] ? live[6].price : fallback.terms[6],
                    12: live[12] ? live[12].price : fallback.terms[12],
                },
            };
        },

        // Plan ObjectId for the selected term — the backend prices the charge off this.
        // Empty until the live plan lands, which is what this page has always sent, so a
        // failed fetch behaves exactly as before instead of blocking the order.
        selectedPlanId() {
            const plan = this.apiPlans[this.paymentInfo.payment_terms];
            return plan ? plan.id : '';
        },

        getProductPricingData() {
            return this.activePricing;
        },

        nextThreeMonthDoses() {
            if (!this.selectedDosage || !this.selectedMedication) {
                return null;
            }

            // Define titration schedules for each medication
            const semaglutideDoses = ['0.25 mg', '0.5 mg', '1.0 mg', '2.0 mg', '2.5 mg'];
            const tirzepatideDoses = ['2.5 mg', '5.0 mg', '7.5 mg', '10.0 mg', '12.5 mg', '15.0 mg'];

            let currentMedication = this.selectedMedication;
            let currentDosage = this.selectedDosage;
            let doses = currentMedication === 'semaglutide' ? semaglutideDoses : tirzepatideDoses;
            let currentIndex = doses.findIndex(dose => dose === currentDosage);

            if (currentIndex === -1) return null;

            const result = [];
            const newHighestDoseIndex = doses.length - 1;

            // Check if staying on same medication (titrate up) or switching (start at current dose)
            const isStayingOnSameMed = (
                (this.currentMedicationType === 'semaglutide' || this.currentMedicationType === 'ozempic') &&
                currentMedication === 'semaglutide'
            ) || (
                (this.currentMedicationType === 'tirzepatide' || this.currentMedicationType === 'mounjaro') &&
                currentMedication === 'tirzepatide'
            );

            // If staying on same medication, titrate up (start from next dose)
            // If switching medications, start from mapped dose
            const startOffset = isStayingOnSameMed ? 1 : 0;

            // Start from current dose (or next dose if titrating) and show next 3 months
            for (let i = 0; i < 3; i++) {
                const monthNumber = i + 1;
                const doseIndex = currentIndex + startOffset + i;

                // If dose index exceeds array, use the highest dose available
                const effectiveDoseIndex = Math.min(doseIndex, newHighestDoseIndex);
                const doseValue = doses[effectiveDoseIndex];
                const numericDose = parseFloat(doseValue);

                result.push({
                    month: monthNumber,
                    dose: numericDose,
                    isHighest: effectiveDoseIndex === newHighestDoseIndex
                });
            }

            return result;
        }
    },
    methods: {
        ...mapActions(['setCartVisibility', 'addToCart', 'clearCart']),

        // Save checkout progress to session storage
        saveProgress() {
            try {
                const progressData = {
                    active_el: this.active_el,
                    people: this.people,
                    selectedMedication: this.selectedMedication,
                    selectedDosage: this.selectedDosage,
                    currentMedicationType: this.currentMedicationType,
                    isTakingGLP1: this.isTakingGLP1,
                    paymentInfo: this.paymentInfo,
                    bmi_calculated: this.bmi_calculated,
                    timestamp: Date.now()
                };
                sessionStorage.setItem('weightLossCheckoutProgress', JSON.stringify(progressData));
            } catch (error) {
                console.error('Error saving progress:', error);
            }
        },

        // Load checkout progress from session storage
        loadProgress() {
            try {
                const savedProgress = sessionStorage.getItem('weightLossCheckoutProgress');
                if (savedProgress) {
                    const progressData = JSON.parse(savedProgress);

                    // Only restore if saved within last 24 hours
                    const dayInMs = 24 * 60 * 60 * 1000;
                    if (Date.now() - progressData.timestamp < dayInMs) {
                        this.active_el = progressData.active_el || 1;
                        this.people = {
                            ...this.people,
                            ...progressData.people
                        };
                        this.selectedMedication = progressData.selectedMedication || '';
                        this.selectedDosage = progressData.selectedDosage || '';
                        this.currentMedicationType = progressData.currentMedicationType || '';
                        this.isTakingGLP1 = progressData.isTakingGLP1;
                        if (progressData.paymentInfo) {
                            this.paymentInfo = {
                                ...this.paymentInfo,
                                ...progressData.paymentInfo
                            };
                        }
                        this.bmi_calculated = progressData.bmi_calculated || '';

                        console.log('Progress restored from session storage');
                    } else {
                        // Clear expired data
                        sessionStorage.removeItem('weightLossCheckoutProgress');
                    }
                }
            } catch (error) {
                console.error('Error loading progress:', error);
            }
        },

        // Clear saved progress
        clearProgress() {
            try {
                sessionStorage.removeItem('weightLossCheckoutProgress');
            } catch (error) {
                console.error('Error clearing progress:', error);
            }
        },
        validateInches() {
            if (this.people.height.inches) {
                let cleaned = String(this.people.height.inches).replace(/\D/g, '');
                if (cleaned.length > 0) {
                    let numValue = parseInt(cleaned, 10);
                    if (numValue > 11) {
                        cleaned = '11';
                    }
                }
                if (cleaned !== String(this.people.height.inches)) {
                    this.people.height.inches = cleaned;
                }
            }
        },

        autoAdvanceDobField(currentFieldId, nextFieldId, maxLength) {
            const currentField = document.getElementById(currentFieldId);
            if (currentField && currentField.value.length === maxLength) {
                const nextField = document.getElementById(nextFieldId);
                if (nextField) {
                    nextField.focus();
                }
            }
        },
        numericOnly(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        },
        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.paymentInfo.couponCode) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            await this.validateCoupon();
        },
        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    payment_terms: this.paymentInfo.payment_terms
                });

                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    if (response.data.c_type === 2) {
                        // Calculate percentage-based discount
                        const planAmount = this.getTotalOrderAmount();
                        const discountPercentage = response.data.c_val;
                        this.paymentInfo.discount = parseFloat(((planAmount * discountPercentage) / 100).toFixed(2));
                    } else {
                        this.paymentInfo.discount = response.data.c_val;
                    }
                    this.updatePaymentRequestAmount();

                } else {
                    this.couponValid = false;
                    this.couponError = true;
                }
            } catch (error) {
                this.couponValid = false;
                this.couponError = true;
            }
        },
        handlePhoneInput(event) {
            // Keep a leading 1 visible as "+1 " instead of swallowing the keypress.
            // cleanUsPhone strips it for validation + submit, so the backend gets 10 digits.
            const formatted = formatUsPhoneInput(event.target.value);
            this.people.phone = formatted;
            // Without this the 11th digit onwards stays in the box: the format never
            // changes past 10 digits, so Vue sees no change and never rewrites the
            // field. Same line the /pre-qualify funnel already carries.
            syncPhoneInput(event, formatted);
            if (this.fieldErrors.phone) this.clearFieldError('phone');
            if (this.showErrorPopup) this.showErrorPopup = false;
        },

        clearFieldError(field) {
            if (this.fieldErrors[field]) {
                this.$set(this.fieldErrors, field, false);
            }
        },

        setFieldError(field, hasError = true) {
            this.$set(this.fieldErrors, field, hasError);
        },

        GoBack() {
            if (this.active_el > 1) {
                if(this.active_el===4){
                    this.active_el=2;
                }else if (this.active_el === 14 && this.isTakingGLP1 === false) {
                    this.active_el = 11;
                }else if(this.active_el===9){
                 this.active_el=7;
                } else {
                    this.active_el--;
                }
                this.fieldErrors = {};
            }
        },
        selectDosage(medication, dosage) {
            try {
                if (window.tracking) {
                    window.tracking.event('medication_dose', { funnel_step: 7, form: 'glp1', medication: medication, dose: dosage });
                }
            } catch (error) { console.log(error); }
            // Medication switching mapping
            const withinTwoWeeksMap = {
                'tirzepatide': {
                    2.5: 0.25, // Always start at lowest dose when switching from Tirzepatide to Semaglutide
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5, // S1 -> T1
                    0.5: 2.5, // S2 -> T1
                    1.0: 5.0, // S3 -> T2
                    1.7: 7.5, // S4 -> T3
                    1.75: 7.5, // S4 -> T3 (alternative format)
                    2.0: 7.5, // S5 -> T3
                    2.4: 10.0, // S6 -> T4
                    2.5: 10.0 // S6 -> T4
                }
            };

            // Check if switching medications
            if (this.selectedMedication && this.selectedDosage && this.selectedMedication !== medication) {
                const currentDoseValue = parseFloat(this.selectedDosage);
                const previousMed = this.selectedMedication;

                // Apply medication switching mapping
                if (withinTwoWeeksMap[previousMed] && withinTwoWeeksMap[previousMed][currentDoseValue]) {
                    const mappedDose = withinTwoWeeksMap[previousMed][currentDoseValue];
                    dosage = mappedDose + ' mg';
                } else {
                    // Fallback to starter doses if mapping not found
                    dosage = medication === 'semaglutide' ? '0.25 mg' : '2.5 mg';
                }
            }

            // Store previous selection for potential future use
            this.previousMedication = this.selectedMedication;
            this.previousDosage = this.selectedDosage;

            // Update current selection
            this.selectedMedication = medication;
            this.selectedDosage = dosage;
            // Advance to next step after a brief delay so user sees their selection
            setTimeout(() => {
                this.active_el++;
            }, 300);
        },

        handleGLP1Selection(isTaking) {
            this.isTakingGLP1 = isTaking;
            try {
                if (window.tracking) {
                    window.tracking.event('glp1_status', { funnel_step: 5, form: 'glp1', glp1_taking: isTaking });
                }
            } catch (error) { console.log(error); }

            // Check BMI qualification
            const bmi = parseFloat(this.bmi_calculated);

            if (isNaN(bmi) || bmi <= 0) {
                this.showError('Please complete the height and weight fields first.');
                return;
            }

            // Qualification logic:
            // - Not taking GLP-1: BMI must be >= 25
            // - Taking GLP-1: BMI must be >= 20
            if (!isTaking && bmi < 20) {
                // Not taking meds and BMI < 25 = disqualified
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "Based on your BMI, you don't currently qualify for this treatment."
                    }
                });
                this.addTagForDisqualify();
                return;
            } else if (isTaking && bmi < 20) {
                // Taking meds and BMI < 20 = disqualified
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "Based on your BMI, you don't currently qualify for this treatment."
                    }
                });
                this.addTagForDisqualify();
                return;
            }

            // Qualified - continue to next step after a brief delay so user sees their selection
            setTimeout(() => {
                if (isTaking) {
                    // Taking GLP-1: go to medication type selection (step 13)
                    this.active_el++;
                } else {
                    // Not taking: clear any previous medication/dosage selections and skip to medication selection (15)
                    this.currentMedicationType = '';
                    this.selectedDosage = '';
                    this.selectedMedication = '';
                    this.active_el += 3;
                }
            }, 300);

        },

        addTagForDisqualify() {
            this.$axios.get(`${this.baseUrl}/api/add-disqualify`);
        },

        handleCurrentMedicationSelection(medication) {
            try {
                if (window.tracking) {
                    window.tracking.event('prior_medications', { funnel_step: 6, form: 'glp1', medication: medication });
                }
            } catch (error) { console.log(error); }
            // Store the current medication type they're taking
            this.currentMedicationType = medication;
            // Advance to dosage selection (step 14) after a brief delay so user sees their selection
            setTimeout(() => {
                this.active_el++;
            }, 300);
        },

        // One shape for every money event on this funnel, so add_to_cart and
        // choose_plan can never report different prices for the same cart.
        cartTrackingParams(funnelStep) {
            const medication = this.selectedMedication === 'semaglutide' ? 'semaglutide' : 'tirzepatide';
            const productName = medication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide';
            const price = this.getTotalOrderAmount();
            let eventId = null;

            try {
                const stored = JSON.parse(localStorage.getItem('tracking_checkout') || '{}');
                if (stored.event_id) eventId = stored.event_id;
            } catch (error) {
                console.error('tracking_checkout read failed', error);
            }

            return {
                funnel_step: funnelStep,
                form: 'glp1',
                event_id: eventId,
                // event_value is the param the pixel spec reads for money. value and
                // items stay alongside it for the reports already built on them.
                event_value: price,
                value: price,
                currency: 'USD',
                // Same resolver the cart and the plan fetch use, so the reported
                // product can never differ from the one being charged.
                product_id: this.checkoutProductId(medication),
                product_name: productName,
                plan_id: this.selectedPlanId || '',
                quantity: 1,
                label: `${medication}_${this.paymentInfo.payment_terms}mo`,
                items: [{
                    item_id: this.selectedMedication || 'GLP1-PROGRAM',
                    item_name: `GLP-1 ${this.selectedMedication || 'Treatment'} - ${this.selectedDosage || 'Starter'}`,
                    price: price,
                    quantity: 1
                }]
            };
        },

        // The plan rows have no Next of their own — the next press is Pay Now — so
        // the tap is the commit. choose_plan records the selection and add_to_cart
        // re-fires at the real price, so a patient who switches plans and then
        // abandons is not reported at the price they moved away from.
        trackPlanChoice() {
            try {
                if (!window.tracking) return;

                const params = this.cartTrackingParams(11);
                window.tracking.event('choose_plan', params);
                window.tracking.event('add_to_cart', params);
                this.lastTrackedPlanId = params.plan_id || null;

                // The order's own purchase reads this record back, wherever it ends up
                // firing from — the payment step, the Klarna return page, or a
                // confirmation link opened tomorrow. Carry the product across too, or
                // that purchase reports the sale with no product id at all.
                const existing = JSON.parse(localStorage.getItem('tracking_checkout') || '{}');
                localStorage.setItem('tracking_checkout', JSON.stringify({
                    ...existing,
                    event_value: params.event_value,
                    currency: 'USD',
                    product_id: params.product_id || '',
                    product_name: params.product_name || ''
                }));
            } catch (error) {
                console.error('choose_plan tracking failed', error);
            }
        },

        advanceStep() {
            if (this.active_el === 15) {
                try {
                    if (window.tracking) {
                        window.tracking.event('add_to_cart', this.cartTrackingParams(10));
                        window.tracking.event('questionnaire_end', { funnel_step: 10, form: 'glp1' });
                    }
                } catch (error) { console.error('add_to_cart tracking failed', error); }
            }
            // Leaving 16 opens the plan picker with 6 months already selected. Report
            // that default now, or every patient who simply accepts it is only ever
            // recorded at the price the step before guessed.
            if (this.active_el === 16) {
                this.trackPlanChoice();
            }
            // Helper method to advance to next step, skipping commented-out steps
            if(this.active_el===7){
                this.active_el = 9;
            }else{
                this.active_el++;
            }
            
        },


        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            if (date > today) {
                return false;
            }

            return true;
        },

        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches);
            const weightInPounds = parseInt(this.people.weight);
            if (heightInInches && weightInPounds) {
                this.people.bmi = (weightInPounds * 703) / (heightInInches * heightInInches);
                this.people.heightInInches = heightInInches;
            }
        },

        showError(message) {
            this.errorMessage = message;
            this.showErrorPopup = true;
        },

        goToLogin() {
            this.showPaidUserModal = false;
            this.$router.push({ path: '/login', query: { email: this.people.email } });
        },

        async checkEmailOnBlur() {
            this.emailCheckError = false;
            this.formErrors.email = '';
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.people.email)) return;

            const result = await checkEmail(this.people.email);
            if (!result.proceed) {
                this.emailCheckError = true;
                if (result.reason === 'wrong_role') {
                    this.formErrors.email = `This email is associated with a ${result.role} account. Please use a different email.`;
                    this.modalMode = 'wrong_role';
                    this.modalRole = result.role;
                    this.showPaidUserModal = true;
                } else if (result.reason === 'paid_user') {
                    this.formErrors.email = 'This email already has an account.';
                    this.modalMode = 'paid';
                    this.showPaidUserModal = true;
                }
            }
        },

        isValidName(name) {
            if (!name || name.trim().length < 2) {
                return false;
            }

            const nameRegex = /^[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF\s']+$/;
            return nameRegex.test(name.trim());
        },

        validateFirstName() {
            if (this.people.first_name && this.people.first_name.trim()) {
                if (!this.isValidName(this.people.first_name)) {
                    this.setFieldError('first_name');
                } else {
                    this.clearFieldError('first_name');
                }
            }
        },

        validateLastName() {
            if (this.people.last_name && this.people.last_name.trim()) {
                if (!this.isValidName(this.people.last_name)) {
                    this.setFieldError('last_name');
                } else {
                    this.clearFieldError('last_name');
                }
            }
        },

        async validateStep(step) {
            this.formErrors = {};
            this.fieldErrors = {};

            switch (step) {
                case 1: 
                    try {
                        if (window.tracking) {
                            await window.tracking.assertSession();
                            window.tracking.event('questionnaire_start', { funnel_step: 1, form: 'glp1' });
                        }
                    } catch (error) {
                        console.log(error)
                    }
                    break;
                case 2: {
                    // Step 2: State, Sex, DOB form
                    let hasError = false;

                    if (!this.people.state) {
                        this.setFieldError('state');
                        hasError = true;
                    }

                    if (!this.people.gender) {
                        this.setFieldError('gender');
                        hasError = true;
                    }

                    const {
                        mm,
                        dd,
                        yyyy
                    } = this.people.dob;

                    if (!mm) {
                        this.setFieldError('dob_mm');
                        hasError = true;
                    }
                    if (!dd) {
                        this.setFieldError('dob_dd');
                        hasError = true;
                    }
                    if (!yyyy) {
                        this.setFieldError('dob_yyyy');
                        hasError = true;
                    }

                    if (hasError) {
                        this.showError('Please complete all required fields');
                        return false;
                    }

                    if (!this.isValidDate(mm, dd, yyyy)) {
                        this.setFieldError('dob_mm');
                        this.setFieldError('dob_dd');
                        this.setFieldError('dob_yyyy');
                        this.showError('Please enter a valid date of birth');
                        return false;
                    }

                    this.people.dobMMDDYYYY = `${mm}/${dd}/${yyyy}`;
                    
                    try {
                        if (window.tracking) {
                            window.tracking.event('state', { funnel_step: 2, form: 'glp1' });
                            window.tracking.event('sex_at_birth', { funnel_step: 2, form: 'glp1' });
                            window.tracking.event('dob_added', { funnel_step: 2, form: 'glp1' });
                        }
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                }

                case 4: {
                    const foot = parseInt(this.people.height.foot);
                    const inches = parseInt(this.people.height.inches);
                    const weight = parseFloat(this.people.weight);

                    let heightError = false;
                    let weightError = false;

                    if (isNaN(foot) || foot < 4 || foot > 8) {
                        this.setFieldError('height_foot');
                        heightError = true;
                    }

                    if (isNaN(inches) || inches < 0 || inches > 11) {
                        this.setFieldError('height_inches');
                        heightError = true;
                    }

                    if (isNaN(weight) || weight < 80 || weight > 700) {
                        this.setFieldError('weight');
                        weightError = true;
                    }

                    if (heightError) {
                        this.showError('Please enter a valid height (4-8 feet, 0-11 inches)');
                        return false;
                    }

                    if (weightError) {
                        this.showError('Please enter a valid weight (80-700 pounds)');
                        return false;
                    }

                    this.people.heightInInches = (foot * 12) + inches;
                    this.people.bmi = (weight * 703) / (this.people.heightInInches * this.people.heightInInches);

                    try {
                        if (window.tracking) {
                            window.tracking.event('height', { funnel_step: 3, form: 'glp1' });
                            window.tracking.event('current_weight', { funnel_step: 3, form: 'glp1' });
                            window.tracking.event('bmi_confirmation', { funnel_step: 3, form: 'glp1' });
                        }
                    } catch (error) {
                        console.log(error)
                    }

                    break;
                }
                case 9:
                    if(this.people.healthConditions){
                        return true
                    }else{
                        return false
                    }
                case 10: {
                    let nameError = false;
                    let errorMessage = '';

                    if (!this.people.first_name || this.people.first_name.trim() === '') {
                        this.setFieldError('first_name');
                        nameError = true;
                        errorMessage = 'Please enter your first name';
                    } else if (!this.isValidName(this.people.first_name)) {
                        this.setFieldError('first_name');
                        nameError = true;
                        if (this.people.first_name.trim().length < 2) {
                            errorMessage = 'First name must be at least 2 characters long';
                        } else {
                            errorMessage = 'First name can only contain letters, spaces, and apostrophes';
                        }
                    }

                    if (!this.people.last_name || this.people.last_name.trim() === '') {
                        this.setFieldError('last_name');
                        nameError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter your last name';
                        } else {
                            errorMessage = 'Please enter valid first and last names';
                        }
                    } else if (!this.isValidName(this.people.last_name)) {
                        this.setFieldError('last_name');
                        nameError = true;
                        if (!errorMessage) {
                            if (this.people.last_name.trim().length < 2) {
                                errorMessage = 'Last name must be at least 2 characters long';
                            } else {
                                errorMessage = 'Last name can only contain letters, spaces, and apostrophes';
                            }
                        } else {
                            errorMessage = 'Names must be at least 2 characters long and contain only letters, spaces, and apostrophes';
                        }
                    }

                    if (!this.isValidEmail) {
                        this.setFieldError('email');
                        nameError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter a valid email address';
                        } else {
                            errorMessage = 'Please complete all fields correctly';
                        }
                    }

                    if (!isValidUsPhone(this.people.phone)) {
                        this.setFieldError('phone');
                        nameError = true;
                        if (!errorMessage) {
                            errorMessage = 'Please enter a valid phone number';
                        }
                    }

                    if (nameError) {
                        this.showError(errorMessage);
                        return false;
                    }

                    if (!this.people.agreed_to_email) {
                        this.$set(this.formErrors, 'emailConsent', 'Please check the consent box to continue');
                        this.shakeConsent = true;
                        return false;
                    }

                    // Check email against existing accounts
                    this.checkingEmail = true;
                    try {
                        const emailResult = await checkEmail(this.people.email);
                        if (!emailResult.proceed) {
                            this.emailCheckError = true;
                            if (emailResult.reason === 'wrong_role') {
                                this.modalMode = 'wrong_role';
                                this.modalRole = emailResult.role;
                                this.showPaidUserModal = true;
                                return false;
                            }
                            if (emailResult.reason === 'paid_user') {
                                this.modalMode = 'paid';
                                this.showPaidUserModal = true;
                                return false;
                            }
                        }
                    } finally {
                        this.checkingEmail = false;
                    }

                    try {
                        if (window.tracking) {
                            window.tracking.event('name_added', { funnel_step: 4, form: 'glp1' });
                            window.tracking.event('phone_added', { funnel_step: 4, form: 'glp1' });
                            window.tracking.event('email_complete', { funnel_step: 4, form: 'glp1' });

                            const partialEventId = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
                            window.tracking.event('partial', { funnel_step: 4, form: 'glp1', event_id: partialEventId });
                            // Persist form + event_id so /payment/thanks can reuse same event_id on purchase
                            try {
                                localStorage.setItem('tracking_checkout', JSON.stringify({
                                    form: 'glp1',
                                    event_id: partialEventId,
                                }));
                            } catch (e) { console.log('tracking_checkout write failed', e); }
                        }
                    } catch (error) {
                        console.log(error)
                    }
                    break;
                }

            }

            return true;
        },

        async handleSubmit() {
            if (!await this.validateStep(this.active_el)) {
                return;
            }

            // Special handling for step 10 - create lead after collecting user details
            if (this.active_el === 10) {
                try {
                    // Age validation
                    if (this.people.dob.yyyy > 2007) {
                        this.$router.push({
                            name: 'leadDisqualified',
                            query: {
                                message: "We cannot proceed since your age is less than 18 years."
                            }
                        });
                        return;
                    }

                    this.people.user_agent = window.navigator.userAgent;
                    
                    try{
                       this.people.tracking_session_id = await window.tracking.assertSession();
                    }catch(error){
                        if (window.trackingSessionId) {
                            this.people.tracking_session_id = window.trackingSessionId;
                        }
                    }

                    

                    // Ensure phone number is cleaned to 10 digits (no leading 1) before sending
                    const cleanedPhone = cleanUsPhone(this.people.phone);

                    // Calculate height in inches and BMI
                    const heightFoot = parseInt(this.people.height.foot) || 0;
                    const heightInches = parseInt(this.people.height.inches) || 0;
                    const heightInInchesTotal = (heightFoot * 12) + heightInches;
                    const weightPounds = parseInt(this.people.weight) || 0;
                    const bmi = weightPounds && heightInInchesTotal ?
                        ((weightPounds * 703) / (heightInInchesTotal * heightInInchesTotal)).toFixed(2) : 0;

                    this.submitted = true;

                    const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, {
                        ...this.people,
                        phone: cleanedPhone,
                        height: {
                            foot: heightFoot,
                            inches: heightInches
                        },
                        heightInInches: heightInInchesTotal,
                        weight: weightPounds.toString(),
                        bmi: parseFloat(bmi),
                        dob: {
                            mm: parseInt(this.people.dob.mm) || 0,
                            dd: parseInt(this.people.dob.dd) || 0,
                            yyyy: parseInt(this.people.dob.yyyy) || 0
                        }
                    }, {
                        headers: {
                            'Content-Type': 'application/json',
                            "Access-Control-Allow-Origin": "*"
                        }
                    });

                    if (response.data.status === 'success') {
                        this.people.id = response.data.user.id;
                        this.$store.dispatch("doLogin", response.data);
                        // Continue to next step instead of routing away
                        this.active_el++;
                    }
                } catch (error) {
                    console.error('Form submission error:', error);
                    this.showError('There was an error submitting your form. Please try again.');
                } finally {
                    this.submitted = false;
                }
                return;
            }

            if(this.active_el===2){
                this.active_el=4
            }else if (this.active_el < this.totalSteps) {
                // Skip step 4 (commented out - category selection)
                this.active_el++;
                return;
            }
        },

        // Payment methods
        handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
            }
        },

        async initStripe() {
            try {
                stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
                // paymentElements is used for express checkout (Apple Pay / Google Pay)
                paymentElements = stripe.elements({
                    mode: 'payment',
                    amount: this.amountInCents,
                    currency: 'usd',
                    paymentMethodTypes: ['card'],
                    paymentMethodCreation: 'manual',
                });
                // elements is used for individual card fields
                elements = stripe.elements();
            } catch (error) {
                console.error('Failed to initialize Stripe:', error);
            }
        },

        updatePaymentRequestAmount() {
            if (!paymentElements) return;
            // No discount subtraction here: amountInCents already nets out the coupon
            // (getTotalOrderAmount subtracts it), so taking it off again showed the
            // wallet customer a total below what they were charged.
            paymentElements.update({ amount: this.amountInCents });
        },

        createExpressCheckout() {
            if (!paymentElements) return;

            if (this.expressCheckoutElement) {
                this.expressCheckoutElement.mount('#express-checkout-element');
                return;
            }

            // NOTE: First try GPay/Apple Pay only. If neither is available,
            // re-create the element with Link enabled as a fallback.
            this.mountExpressCheckout({ allowLink: false });
        },

        mountExpressCheckout({ allowLink }) {
            const paymentMethods = {
                applePay: 'auto',
                googlePay: 'auto',
                paypal: 'never',
                amazonPay: 'never',
            };
            paymentMethods.link = allowLink ? 'auto' : 'never';

            this.expressCheckoutElement = paymentElements.create('expressCheckout', {
                buttonHeight: 48,
                paymentMethods,
                paymentMethodOrder: ['googlePay', 'applePay', 'link'],
                layout: {
                    overflow: 'never',
                },
            });
            this.expressCheckoutElement.on('ready', ({ availablePaymentMethods }) => {
                // If GPay/Apple Pay aren't available and we haven't tried Link yet,
                // recreate with Link enabled as fallback.
                if (!allowLink && !availablePaymentMethods) {
                    this.expressCheckoutElement.unmount();
                    this.expressCheckoutElement.destroy();
                    this.expressCheckoutElement = null;
                    this.mountExpressCheckout({ allowLink: true });
                    return;
                }
                this.canMakeExpressCheckout = !!availablePaymentMethods;
            });
            this.expressCheckoutElement.on('confirm', this.handleExpressCheckoutConfirm);
            this.expressCheckoutElement.mount('#express-checkout-element');
        },

        async handleExpressCheckoutConfirm(event) {
            if (this.submitted) { event.paymentFailed({ reason: 'fail' }); return; } // a charge is already in flight
            if (this.stopForBlockedState(event.billingDetails?.address?.state)) { event.paymentFailed({ reason: 'fail' }); return; }
            try {
                this.submitted = true;
                this.paymentError = false;

                const { error: submitError } = await paymentElements.submit();
                if (submitError) {
                    event.paymentFailed({ reason: 'invalid_payment_data' });
                    this.paymentError = true;
                    this.errorMessage = submitError.message || 'Payment failed.';
                    this.submitted = false;
                    return;
                }

                const { paymentMethod, error } = await stripe.createPaymentMethod({
                    elements: paymentElements,
                });

                if (error) {
                    event.paymentFailed({ reason: 'invalid_payment_data' });
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Payment failed.';
                    this.submitted = false;
                    return;
                }

                if (event.billingDetails?.address) {
                    const addr = event.billingDetails.address;
                    this.billingAddress = {
                        addressLine1: addr.line1 || '',
                        addressLine2: addr.line2 || '',
                        city: addr.city || '',
                        state: addr.state || '',
                        zip: addr.postal_code || ''
                    };
                }

                this.paymentInfo.cardToken = paymentMethod.id;
                // Link rides in this same element as the fallback button, so the old
                // "apple_pay or else google_pay" test filed every Link order as Google Pay.
                this.paymentInfo.paymentMethod = paymentMethodFromExpressType(event.expressPaymentType);
                try {
                    this.paymentInfo.cardDetails = {
                        number: `XXXXXXXXXXXX${paymentMethod.card.last4}`,
                        expiration_month: paymentMethod.card.exp_month,
                        expiration_year: paymentMethod.card.exp_year,
                        cardBin: '',
                        cardBrand: paymentMethod.card.brand,
                        cardLast4: paymentMethod.card.last4,
                    };
                    this.paymentInfo.cardLast4 = paymentMethod.card.last4;
                    this.paymentInfo.cardBrand = paymentMethod.card.brand;
                } catch (e) {
                    console.warn('Could not extract card details from paymentMethod', e);
                }
                await this.processPayment();
            } catch (err) {
                console.error('Express checkout payment failed:', err);
                event.paymentFailed({ reason: 'fail' });
                this.paymentError = true;
                this.errorMessage = 'Payment failed. Please try again or use a different payment method.';
                this.submitted = false;
            }
        },

        createCardElement() {
            if (!elements) return;

            const cardStyle = {
                base: {
                    color: '#32325d',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': { color: '#aab7c4' }
                },
                invalid: { color: '#fa755a', iconColor: '#fa755a' }
            };

            if (!this.cardNumberElement) {
                this.cardNumberElement = elements.create('cardNumber', {
                    style: cardStyle,
                    showIcon: false,
                    placeholder: '1234 1234 1234 1234'
                });
                this.cardNumberElement.mount('#card-number-element');
                this.cardNumberElement.on('ready', () => { this.paymentElementReady = true; });
                this.cardNumberElement.on('change', (event) => { this.hasCardInput = event.complete; });
            }

            if (!this.cardExpiryElement) {
                this.cardExpiryElement = elements.create('cardExpiry', { style: cardStyle });
                this.cardExpiryElement.mount('#card-expiry-element');
            }

            if (!this.cardCvcElement) {
                this.cardCvcElement = elements.create('cardCvc', { style: cardStyle });
                this.cardCvcElement.mount('#card-cvc-element');
            }
        },

        changePaymentTerms(value) {
            const moved = this.paymentInfo.payment_terms !== value;
            this.paymentInfo.payment_terms = value;
            this.updatePaymentRequestAmount();
            // Each plan row is a <label> wrapping its radio, so the browser runs this
            // handler twice for one tap. Report only the call that moved the plan, or
            // every switch double-counts in the ad platforms.
            if (moved) {
                this.trackPlanChoice();
            }
        },

        async continueFromStep17() {
            this.active_el++;
            this.$nextTick(async () => {
                await this.initStripe();
                this.createCardElement();
                this.createExpressCheckout();
            });
        },

        async selectMedication(medication) {
            try {
                if (window.tracking) {
                    window.tracking.event('treatment_selection', { funnel_step: 8, form: 'glp1', medication: medication });
                }
            } catch (e) {
                console.log('Error recording treatment selection event', e);
            }
            // Dose mapping when switching from Semaglutide to Tirzepatide
            const semaToTirzMapping = {
                0.25: 2.5, // S1 -> T1
                0.5: 2.5, // S2 -> T1
                1.0: 5.0, // S3 -> T2
                1.5: 7.5, // S4 -> T3
                2.0: 7.5, // S5 -> T3
                2.5: 10.0 // S6 -> T4
            };

            // If not currently taking any GLP-1, set to lowest dose
            if (!this.currentMedicationType || this.currentMedicationType === '') {
                this.selectedDosage = medication === 'tirzepatide' ? '2.5 mg' : '0.25 mg';
            }
            // Switching from Semaglutide/Ozempic to Tirzepatide
            else if (medication === 'tirzepatide' &&
                (this.currentMedicationType === 'semaglutide' || this.currentMedicationType === 'ozempic') &&
                this.selectedDosage) {

                // Parse the current semaglutide dose
                const currentDose = parseFloat(this.selectedDosage);

                // Map to tirzepatide dose
                if (semaToTirzMapping[currentDose]) {
                    const mappedDose = semaToTirzMapping[currentDose];
                    this.selectedDosage = mappedDose.toFixed(1) + ' mg';
                }
            }
            // Switching from Tirzepatide/Mounjaro to Semaglutide
            else if (medication === 'semaglutide' &&
                (this.currentMedicationType === 'tirzepatide' || this.currentMedicationType === 'mounjaro') &&
                this.selectedDosage) {

                // Always start at lowest Semaglutide dose when switching from Tirzepatide
                this.selectedDosage = '0.25 mg';
            }

            this.selectedMedication = medication;
            await this.createAndSaveCart(medication);
        },

        // The cheapest per-month price a medication can be bought at — the "From $"
        // figure on the treatment cards. Every term is divided by its own length and the
        // smallest wins, which is the 12-month plan, matching what the card advertised
        // before these prices came from the API. Live plans when they have landed, the
        // local fallback until then.
        lowestMonthlyFor(medication) {
            const live = this.plansByProduct[this.checkoutProductId(medication)];
            const monthlies = [];

            if (live) {
                Object.keys(live).forEach((terms) => {
                    const months = Number(terms);
                    const price = live[terms] && live[terms].price;
                    if (months > 0 && price != null) monthlies.push(Number(price) / months);
                });
            }

            if (monthlies.length === 0) {
                const fallback = medication === 'semaglutide' ?
                    this.pricingConfig.semaglutide :
                    this.pricingConfig.tirzepatide;
                monthlies.push(fallback.monthly.first);
                Object.keys(fallback.terms).forEach((terms) => {
                    const months = Number(terms);
                    if (months > 0) monthlies.push(fallback.terms[terms] / months);
                });
            }

            return Number(Math.min(...monthlies).toFixed(2));
        },

        // Split a price for the templates that render the cents as a superscript.
        priceDollars(amount) {
            return Math.floor(Number(amount) || 0);
        },

        priceCents(amount) {
            return ((Number(amount) || 0) % 1).toFixed(2).split('.')[1];
        },

        // The two products /glp1 sells. Resolved with the SAME rule that prices the
        // order — getProductPricing() treats anything that is not semaglutide as
        // tirzepatide — so the cart line can never name a different medication than
        // the one the customer was charged for.
        checkoutProductId(medication) {
            const selected = medication || this.selectedMedication;
            return selected === 'semaglutide' ?
                '675ac4cb6bf102c19ec3afec' :
                '675ac4cb6bf102c19ec3afe9';
        },

        // Live plans for one medication (the selected one when no argument). Safe to call
        // repeatedly: the in-flight request per product is shared, and an already-cached
        // product only re-applies itself to the selected-medication pricing.
        loadPlans(medication) {
            const productId = this.checkoutProductId(medication);
            const cached = this.plansByProduct[productId];
            if (cached) {
                this.applyPlansIfSelected(productId, cached);
                return Promise.resolve(true);
            }
            if (!plansRequests[productId]) {
                plansRequests[productId] = this.fetchPlansWithRetry(productId);
            }
            return plansRequests[productId];
        },

        // Promotes a product's plans to the prices this order is charged off, but only
        // while that product is still the selected one — so a late response for a
        // medication the customer switched away from can't reprice their order.
        applyPlansIfSelected(productId, plans) {
            if (this.checkoutProductId() !== productId) return;
            this.apiPlans = plans;
            this.apiPlansProductId = productId;
            // Plans can land after Stripe was set up on the fallback price, so
            // resync the Apple/Google Pay sheet to the live total.
            this.updatePaymentRequestAmount();
            // The picker reports its pre-selected plan as the step opens, which can
            // beat this fetch. That first report carries the fallback price and no
            // plan id, so replace it now that the real record is here — otherwise a
            // backend price change is charged at the new price and reported at the old.
            // active_el >= 16 means the picker is open, so it has already reported once.
            if (this.active_el >= 16 && this.selectedPlanId
                && this.selectedPlanId !== this.lastTrackedPlanId) {
                this.trackPlanChoice();
            }
        },

        async fetchPlansWithRetry(productId) {
            for (let attempt = 0; attempt < PLANS_MAX_ATTEMPTS; attempt++) {
                if (attempt > 0) {
                    await new Promise((resolve) => setTimeout(resolve, PLANS_RETRY_BACKOFF_MS[attempt - 1]));
                }
                if (await this.fetchPlansOnce(productId)) {
                    delete plansRequests[productId];
                    return true;
                }
            }
            // Cleared so a later attempt can start a fresh chain rather than reusing
            // this settled failure.
            delete plansRequests[productId];
            return false;
        },

        async fetchPlansOnce(productId) {
            try {
                if (!productId) return false;
                // isPromo: the sale plan list, same as checkoutWeightLoss and
                // checkoutCallCenter — all three checkouts now sell one set of prices.
                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                    params: { isPromo: true, productId },
                    timeout: PLANS_REQUEST_TIMEOUT_MS
                });
                if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                    const plans = {};
                    // is_active is deliberately NOT checked: plan records are always live,
                    // and the flag is not maintained. Filtering on it would silently drop a
                    // real plan and price the order off the local fallback instead. Same as
                    // checkoutWeightLoss and checkoutCallCenter.
                    response.data.plans.forEach((plan) => {
                        if (plan && plan.terms != null && plan.price != null) {
                            plans[Number(plan.terms)] = { id: plan.id, price: Number(plan.price) };
                        }
                    });
                    if (Object.keys(plans).length > 0) {
                        // Cached per product either way: the treatment picker prices both
                        // medications, so the one not currently selected is still needed.
                        this.$set(this.plansByProduct, productId, plans);
                        this.applyPlansIfSelected(productId, plans);
                        return true;
                    }
                }
            } catch (error) {
                console.error('Error loading plans:', error);
            }
            return false;
        },

        // Builds the medication cart line from the catalog record. Returns null when the
        // catalog has not loaded, so callers can tell "no line" from a broken line.
        buildOrderCartLine(medication) {
            const product = getProductById(this.checkoutProductId(medication));
            const plan = product && product[0];
            if (!plan) return null;

            return {
                id: plan.id,
                name: plan.name,
                category: plan.category.primary,
                price: plan.pricing.retail_price,
                retail_price: plan.pricing.retail_price,
                subheader: 'Compound Medication',
                sku: plan.sku,
                stripe_id: plan.stripe_id,
                quantity: 1,
                image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                is_addon: false,
            };
        },

        async createAndSaveCart(medication) {
            this.isLoading = true;

            await this.clearCart();

            try {
                const cartItem = this.buildOrderCartLine(medication);
                if (!cartItem) throw new Error('product not found in catalog');

                // Update tracking_checkout payload so purchase event on /payment/thanks has product details
                try {
                    const existing = JSON.parse(localStorage.getItem('tracking_checkout') || '{}');
                    localStorage.setItem('tracking_checkout', JSON.stringify({
                        ...existing,
                        product_name: cartItem.name,
                        product_id: cartItem.sku,
                        event_value: cartItem.retail_price,
                        currency: 'USD',
                    }));
                } catch (e) { console.log('tracking_checkout update failed', e); }

                await this.saveCart(cartItem);
            } catch (error) {
                console.error('Error creating cart:', error);
                this.showError('Error adding item to cart. Please try again.');
                this.isLoading = false;
            }
        },

        async saveCart(cartItem) {
            this.isLoading = true;

            let postData = {
                ...cartItem,
                is_addon: false,
                sema_offer: this.$store.getters.offerSema,
                tir_offer: this.$store.getters.offerTir,
            };

            try {
                const response = await this.$axios.post(`${this.baseUrl}/forms/save-cart`, postData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (response.data.status === 'success') {
                    this.cartId = response.data.id;
                    this.$store.dispatch('addToCart', cartItem);
                    this.setCartVisibility(false);
                    try {
                        if (window.tracking) {
                            window.tracking.event('inclusions_viewed', { funnel_step: 9, form: 'glp1' });
                        }
                    } catch (e) {
                        console.log('Error recording inclusions viewed event', e);
                    }
                    this.active_el++;
                    this.isLoading = false;
                } else {
                    this.showError('Unexpected response from server');
                    this.isLoading = false;
                }
            } catch (error) {
                console.error('Error saving cart:', error);
                this.showError('Error saving cart. Please try again.');
                this.isLoading = false;
            }
        },

        getMedicationDetails() {
            if (this.selectedMedication === 'tirzepatide') {
                return {
                    name: 'Tirzepatide',
                    subtitle: 'COMPOUNDED W/ B6',
                    image: require('@/assets/images/checkout-sema.png'),
                    straightImage: require('@/assets/images/checkout-sema.png'),
                    type: 'Subcutaneous Injection',
                    description: 'The most popular, GLP-2 weight loss program that works on two Glucagon receptor.'
                };
            } else {
                return {
                    name: 'Semaglutide',
                    subtitle: 'COMPOUNDED W/ B12',
                    image: require('@/assets/images/checkout-sema.png'),
                    straightImage: require('@/assets/images/checkout-sema.png'),
                    type: 'Subcutaneous Injection',
                    description: 'The original, GLP-1 weight loss program that works on one Glucagon receptor.'
                };
            }
        },

        // Gate on every payment path. An empty planId makes the backend fall back to
        // its full price, so the customer would be shown the sale and billed the
        // regular rate. Refusing the charge is cheaper than that and the chargeback
        // that follows. Waits only on the in-flight load, capped, so the customer
        // never sits at a dead button.
        async requirePlanId() {
            if (this.selectedPlanId) return true;

            await Promise.race([
                this.loadPlans(),
                new Promise((resolve) => setTimeout(resolve, PLANS_PAY_WAIT_MS))
            ]);
            if (this.selectedPlanId) return true;

            this.paymentError = true;
            this.errorMessage = 'We could not confirm current pricing. Please try again in a moment.';
            this.submitted = false;
            return false;
        },

        getProductPricing() {
            return this.activePricing;
        },

        getFirstMonthPrice() {
            return this.getProductPricing().monthly.first;
        },

        getRegularMonthlyPrice() {
            return this.getProductPricing().monthly.regular;
        },

        getTotalPrice(term) {
            if (term == 1) {
                return parseFloat(this.getFirstMonthPrice().toFixed(2));
            }
            return parseFloat(this.getProductPricing().terms[term].toFixed(2));
        },

        getCurrentPrice() {
            if (this.paymentInfo.payment_terms === 1) {
                return parseFloat(this.getFirstMonthPrice().toFixed(2));
            } else {
                return parseFloat(this.getTotalPrice(this.paymentInfo.payment_terms).toFixed(2));
            }
        },

        getTotalOrderAmount() {
            const basePrice = this.getCurrentPrice();
            const discount = this.paymentInfo.discount || 0;
            return Math.max(0, basePrice - discount);
        },

        // The cart sent to the payment endpoints.
        //
        // Falls back to rebuilding the medication line from the catalog when the Vuex
        // cart is empty — a refresh on the payment step drops that cart, and the
        // backend creates nothing and returns no transaction id for a payload with no
        // lines. Until the add-on was moved out of checkout, the pre-ticked box meant a
        // line was always present and this was never exposed.
        // Repriced to the selected term, so cartItems[].price matches the amount charged
        // instead of the per-month price the cart was saved with — the cart line said
        // $349.97 next to a $647.97 charge. Same shape checkoutWeightLoss sends.
        orderCartItems() {
            const item = (this.cartItems && this.cartItems.length > 0) ?
                this.cartItems[0] :
                this.buildOrderCartLine();
            if (!item) return [];

            return [{
                ...item,
                quantity: item.quantity || 1,
                price: this.getTotalOrderAmount(),
                retail_price: this.getCurrentPrice(),
            }];
        },

        // The medication the order is actually for. selectedMedication is empty when the
        // payment step is reached without touching the picker, which left the payload
        // selling Tirzepatide with an empty medication field. The line resolved for the
        // charge is the only truthful source at that point, and its name lowercases to
        // the same slug the picker sets.
        orderMedication() {
            if (this.selectedMedication) return this.selectedMedication;
            const line = this.orderCartItems()[0];
            return (line && line.name) ? String(line.name).toLowerCase() : '';
        },

        // Offers Priority Physician Review if the catalog has it, otherwise goes
        // straight to the confirmation. Called only after the order is captured, so
        // the redirect is stashed rather than dropped: whichever way the customer
        // answers, pushToRoute still runs with the order's own amount and id.
        offerFastTrackOrRoute(amountCharged, transactionIdentifier) {
            if (!this.fastTrackAddon) {
                this.pushToRoute(amountCharged, transactionIdentifier);
                return;
            }
            this.fastTrackPendingRoute = { amountCharged, transactionIdentifier };
            this.fastTrackOfferOpen = true;
        },

        closeFastTrackOffer() {
            this.fastTrackOfferOpen = false;
            const pending = this.fastTrackPendingRoute;
            this.fastTrackPendingRoute = null;
            if (pending) {
                this.pushToRoute(pending.amountCharged, pending.transactionIdentifier);
            }
        },

        getAddressData(address) {
            if (this.isPOBox(address.street)) {
                this.showError('Our shipping partners do not deliver to PO Box addresses.');
                return;
            }
            this.customerInfo.addressLine1 = address.street;
            this.customerInfo.addressLine2 = address.address_line2 || '';
            this.customerInfo.city = address.city;
            this.customerInfo.state = address.state;
            this.customerInfo.zip = address.zip;
        },

        getAddressDataBilling(address) {
            this.billingAddress.addressLine1 = address.street;
            this.billingAddress.addressLine2 = address.address_line2 || '';
            this.billingAddress.city = address.city;
            this.billingAddress.state = address.state;
            this.billingAddress.zip = address.zip;
        },

        showToast(msg) {
            this.toastMessage = '';
            this.$nextTick(() => {
                this.toastMessage = msg;
                setTimeout(() => { this.toastMessage = ''; }, 5000);
            });
        },

        blinkAddress() {
            this.addressBlink = false;
            this.$nextTick(() => {
                this.addressBlink = true;
                setTimeout(() => { this.addressBlink = false; }, 1500);
            });
        },

        isPOBox(address) {
            const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
            const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
            return poBoxRegex.test(normalized);
        },

        validateAddress(address) {
            return address.addressLine1 &&
                address.city &&
                address.state &&
                address.zip;
        },

        // GLP-1 cannot be sold in Louisiana or Mississippi (state law). Runs before every
        // charge: card, Klarna, and Apple Pay / Google Pay / Link, whose wallet billing
        // state is passed in. Shows the refusal and returns true when the sale must stop.
        stopForBlockedState(walletBillingState) {
            const states = [this.customerInfo.state, this.differentShipping ? this.billingAddress.state : '', walletBillingState];
            if (!states.some(isBlockedState)) return false;
            this.paymentError = true;
            this.errorMessage = BLOCKED_STATE_MESSAGE;
            this.submitted = false;
            return true;
        },

        async getStripeToken() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            this.paymentError = false;
            this.checkoutErrorMessage = '';
            if (this.stopForBlockedState()) return false;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete shipping address.";
                this.submitted = false;
                this.blinkAddress();
                if (window.innerWidth <= 479) { this.$nextTick(() => { document.querySelector('.shipping-address-label')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }); }
                return false;
            }

            if (this.differentShipping && !this.validateAddress(this.billingAddress)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete billing address.";
                this.submitted = false;
                return false;
            }

            try {
                const billingDetails = {
                    name: `${this.user?.first_name || ''} ${this.user?.last_name || ''}`.trim(),
                    email: this.user?.email || '',
                    address: {
                        line1: this.customerInfo.addressLine1,
                        line2: this.customerInfo.addressLine2 || '',
                        city: this.customerInfo.city,
                        state: this.customerInfo.state,
                        postal_code: this.customerInfo.zip,
                        country: 'US',
                    },
                };

                const { paymentMethod, error } = await stripe.createPaymentMethod({
                    type: 'card',
                    card: this.cardNumberElement,
                    billing_details: billingDetails,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Invalid card details. Please check your card information.';
                    this.submitted = false;
                    return;
                }

                this.paymentInfo.cardToken = paymentMethod.id;
                this.paymentInfo.paymentMethod = 'card';
                try {
                    this.paymentInfo.cardDetails = {
                        number: `XXXXXXXXXXXX${paymentMethod.card.last4}`,
                        expiration_month: paymentMethod.card.exp_month,
                        expiration_year: paymentMethod.card.exp_year,
                        cardBin: '',
                        cardBrand: paymentMethod.card.brand,
                        cardLast4: paymentMethod.card.last4,
                    };
                    this.paymentInfo.cardLast4 = paymentMethod.card.last4;
                    this.paymentInfo.cardBrand = paymentMethod.card.brand;
                } catch (e) {
                    console.warn('Could not extract card details from paymentMethod', e);
                }
                this.processPayment();
            } catch (error) {
                console.error(error);
                this.paymentError = true;
                this.errorMessage = 'Invalid card details. Please check your card information.';
                this.submitted = false;
            }
        },

        ensureCorrelationId() {
            try {
                if (this.correlationId) return this.correlationId;
                if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
                    this.correlationId = crypto.randomUUID();
                    return this.correlationId;
                }
                this.correlationId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    const r = (Math.random() * 16) | 0;
                    const v = c === 'x' ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                });
                return this.correlationId;
            } catch (e) {
                console.log('correlation id generation failed', e);
                this.correlationId = '';
                return '';
            }
        },

        async payWithKlarna() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // Fresh idempotency key per Klarna attempt (sent as X-Correlation-Id header below).
            this.correlationId = '';
            this.ensureCorrelationId();
            this.paymentError = false;
            this.checkoutErrorMessage = '';
            if (this.stopForBlockedState()) return;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete shipping address.';
                this.submitted = false;
                this.blinkAddress();
                if (window.innerWidth <= 479) { this.$nextTick(() => { document.querySelector('.shipping-address-label')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }); }
                return;
            }
            if (this.differentShipping && !this.validateAddress(this.billingAddress)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete billing address.';
                this.submitted = false;
                return;
            }
            if (this.isPOBox(this.customerInfo.addressLine1)) {
                this.paymentError = true;
                this.errorMessage = 'PO Box addresses are not accepted.';
                this.submitted = false;
                return;
            }
            if (!await this.requirePlanId()) return;

            try {
                const billingAddr = this.differentShipping ? this.billingAddress : this.customerInfo;
                const shippingAddress = {
                    addressLine1: this.customerInfo.addressLine1,
                    addressLine2: this.customerInfo.addressLine2,
                    city: this.customerInfo.city,
                    state: this.customerInfo.state,
                    zip: this.customerInfo.zip,
                };

                // amountInCents already nets out the coupon (getTotalOrderAmount subtracts it
                // from the gross getCurrentPrice), so subtracting discount again here charged
                // it twice. discount/couponId still go in the payload below for the record —
                // the backend authorizes `amount` as sent, same as the other two checkouts.
                const chargeAmount = this.amountInCents;

                this.trackingSessionId = window.trackingSessionId || 'unknown';

                const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-intent`, {
                    id: this.user?.id || 'guest-' + Date.now(),
                    amount: chargeAmount,
                    payment_method_types: ['klarna'],
                    user_id: this.user?.id || 'guest-' + Date.now(),
                    // Was `this.getOfferName`, which this component does not define — the
                    // key serialized as undefined and never reached the backend at all.
                    planId: this.selectedPlanId,
                    payment_terms: this.paymentInfo.payment_terms,
                    couponCode: this.paymentInfo.couponId ? (this.paymentInfo.couponCode || '') : '',
                    couponId: this.paymentInfo.couponId,
                    discount: this.paymentInfo.discount,
                    firstName: this.user?.first_name,
                    lastName: this.user?.last_name,
                    email: this.user?.email,
                    cartTotal: this.getTotalOrderAmount(),
                    mainProductTotal: this.getTotalOrderAmount(),
                    addonTotal: 0,
                    totalOrderAmount: this.getTotalOrderAmount(),
                    tracking_session_id: this.trackingSessionId,
                    shippingAddress,
                    billingAddress: {
                        addressLine1: billingAddr.addressLine1,
                        addressLine2: billingAddr.addressLine2,
                        city: billingAddr.city,
                        state: billingAddr.state,
                        zip: billingAddr.zip,
                    },
                    cartItems: this.orderCartItems(),
                    medication: this.paymentInfo.medication || this.orderMedication(),
                    dosage: this.selectedDosage,
                }, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });

                const { clientSecret } = response.data;
                const currentUrl = window.location.origin;
                const returnUrl = `${currentUrl}/checkout-flow/klarna-return`;

                // Snapshot the priced cart BEFORE redirecting to Klarna. KlarnaReturn.vue is
                // a fresh page load after the redirect and can't see this component's cart,
                // so it reads this back to send cartItems on /api/confirm-klarna-payment.
                // Keyed to this payment intent so a stale snapshot never attaches to another
                // checkout that shares KlarnaReturn.vue.
                try {
                    const mainItem = this.orderCartItems()[0] || null;
                    if (mainItem && mainItem.id) {
                        const snapshotItems = [{
                            id: mainItem.id,
                            quantity: 1,
                            price: Number((chargeAmount / 100).toFixed(2)),
                        }];
                        sessionStorage.setItem('pending_klarna_cart', JSON.stringify({
                            payment_intent_id: clientSecret.split('_secret')[0],
                            items: snapshotItems,
                        }));
                    }
                } catch (e) { /* sessionStorage unavailable — confirm falls back to paymentIntentId only */ }

                const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
                    payment_method: {
                        billing_details: {
                            name: `${this.user?.first_name || ''} ${this.user?.last_name || ''}`.trim(),
                            email: this.user?.email,
                            address: {
                                line1: billingAddr.addressLine1,
                                line2: billingAddr.addressLine2 || '',
                                city: billingAddr.city,
                                state: billingAddr.state,
                                postal_code: billingAddr.zip,
                                country: 'US',
                            },
                        },
                    },
                    return_url: returnUrl,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Klarna payment failed. Please try again.';
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Failed to initiate Klarna payment. Please try again.';
                this.submitted = false;
            }
        },

        async processPayment() {
            // Covers the card form and the Apple/Google Pay sheet, which both land here.
            if (!await this.requirePlanId()) return;

            // Fresh idempotency key per payment attempt. Sent as the X-Correlation-Id
            // header on the charge so the backend's Stripe idempotency key blocks a
            // duplicate of THIS same attempt from creating a second charge.
            this.correlationId = '';
            this.ensureCorrelationId();

            try {
                this.submitted = true;
                this.paymentError = false;
                this.paymentInfo.user_id = this.user.id;
                this.paymentInfo.id = this.user.id;
                this.paymentInfo.medication = this.orderMedication();

                this.trackingSessionId = window.trackingSessionId || 'unknown';

                let paymentData = {
                    ...this.paymentInfo,
                    planId: this.selectedPlanId,
                    amount: this.amountInCents,
                    // The selected term's totals, not the Vuex cart's per-month figure —
                    // that read $349.97 beside a $647.97 charge, and was 0 outright after a
                    // refresh on the payment step dropped the cart.
                    cartTotal: this.getTotalOrderAmount(),
                    cartTotalNoDiscount: this.getCurrentPrice(),
                    billingAddress: this.differentShipping ? this.billingAddress : this.customerInfo,
                    shippingAddress: this.customerInfo,
                    categories: this.people.categories,
                    dosage: this.selectedDosage,
                    cartItems: this.orderCartItems(),
                    totalOrderAmount: this.getTotalOrderAmount(),
                    user_agent: window.navigator.userAgent || 'unknown',
                    ip_address: this.people.ip_address || 'unknown',
                    tracking_session_id: this.trackingSessionId
                };

                const response = await this.$axios.post(`${this.baseUrl}/api/checkout-stripe`, paymentData, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });
                // Drives the purchase event's event_value on the thanks page. The coupon is
                // NOT subtracted again — getTotalOrderAmount already took it off before
                // amountInCents, so the old expression reported it twice. Priority review
                // is charged separately and fires its own purchase, so it is deliberately
                // not folded in here.
                let amountCharged = paymentData.amount / 100;

                // 3D Secure: the bank's popup for each client secret (utils/bankCheck.js),
                // on the same Stripe instance that made the card and wallet PaymentMethods.
                // Passing it is paid: the backend activates the order from Stripe's webhook.
                const bankCheck = needsBankCheck(response.data)
                    ? await runBankChecks(stripe, response.data.client_secrets)
                    : null;
                if (response.data.status === 'success' || (bankCheck && bankCheck.ok)) {
                    try {
                        if (this.paymentInfo.cardLast4) {
                            localStorage.setItem('rxpros_card_on_file', JSON.stringify({
                                last4: this.paymentInfo.cardLast4,
                                brand: this.paymentInfo.cardBrand || '',
                            }));
                        }
                    } catch (e) { console.log(e); }
                    let transactionIdentifier;
                    await this.updateAddress();
                    await this.clearCart();

                    try {
                        if (response.data.transaction_id) {
                            transactionIdentifier = response.data.transaction_id;
                        } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                            transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                        } else {
                            transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                        }
                    } catch (e) {
                        console.log(e);
                        transactionIdentifier = `${Date.now()}`;
                    }

                    // Report the order here, where the server has confirmed it — not on the
                    // thanks page. The add-on offer now sits between this point and that
                    // redirect, so a customer who closes the tab at the offer still counts.
                    // The thanks page skips anything already reported.
                    fireOrderPurchase({ amount: amountCharged, transactionId: transactionIdentifier });

                    this.offerFastTrackOrRoute(amountCharged, transactionIdentifier);

                    // keep submitted = true through the redirect (do NOT re-enable on success — prevents redirect-gap double-charge)
                } else {
                    this.checkoutErrorMessage = bankCheck
                        ? (bankCheck.message || "Payment failed")
                        : shopperMessage(response.data.message, "Payment failed");
                    // Part of the order went through before the bank refused the rest, so
                    // a retry would charge that part again: the button stays locked.
                    this.submitted = !!(bankCheck && bankCheck.confirmed);
                }
            } catch (error) {
                this.submitted = false;
                // A backend without the 3D Secure change refuses the card with Stripe's
                // own developer text; the shopper gets this page's line instead.
                this.checkoutErrorMessage = shopperMessage(error.response?.data?.message, "Payment failed");
                   
            }
        },

        pushToRoute(amountCharged, transaction_id) {
            try {
                const query = {};
                if (this.paymentInfo.payment_terms !== null) {
                    query.terms = String(this.paymentInfo.payment_terms);
                }
                query.amount = amountCharged;
                query.trans_id = transaction_id;
                this.$router.push({
                    name: 'prescriptionThanks',
                    query
                });
            } catch (error) {
                console.log(error);
                this.$router.push({
                    name: 'prescriptionThanks'
                });
            }
        },
        async updateAddress() {
            try {
                this.customerInfo.id = this.user?.id || 'guest-' + Date.now();
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
                // Don't throw error here, as it might block payment flow
            }
        },
        async finalSubmit() {
            if (!await this.validateStep(this.active_el)) {
                return;
            }

            try {
                // Age validation
                if (this.people.dob.yyyy > 2007) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years."
                        }
                    });
                    return false;
                }

                this.people.user_agent = window.navigator.userAgent;
                try{
                       this.people.tracking_session_id = await window.tracking.assertSession();
                    }catch(error){
                        if (window.trackingSessionId) {
                            this.people.tracking_session_id = window.trackingSessionId;
                        }
                    }

                // Ensure phone number is cleaned to 10 digits (no leading 1) before sending
                const cleanedPhone = cleanUsPhone(this.people.phone);

                this.submitted = true;

                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, {
                    ...this.people,
                    phone: cleanedPhone,
                    height: {
                        foot: parseInt(this.people.height.foot) || 0,
                        inches: parseInt(this.people.height.inches) || 0
                    },
                    weight: parseInt(this.people.weight) || 0,
                    dob: {
                        mm: parseInt(this.people.dob.mm) || 0,
                        dd: parseInt(this.people.dob.dd) || 0,
                        yyyy: parseInt(this.people.dob.yyyy) || 0
                    }
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                });

                if (response.data.status === 'success') {
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.$router.push({
                        name: 'choosePlan'
                    });
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.showError('There was an error submitting your form. Please try again.');
            } finally {
                this.submitted = false;
            }
        }
    },

    watch: {
        'people.agreed_to_email'(newVal) {
            if (newVal && this.formErrors.emailConsent) {
                this.$delete(this.formErrors, 'emailConsent');
            }
        },
        active_el() {
            // Save progress when step changes
            this.saveProgress();

            // Wait for DOM update, then scroll to question
            this.$nextTick(() => {
                const questionDiv = document.querySelector('.step_forminfo_div, .quizquestiondiv2-copy, .quizquestiondiv2, .question-div-2, .glpquiz_div, .step2_div', 'step4_div', 'step5_div', 'step6_div');
                if (questionDiv) {
                    const header = document.querySelector('.section-fixed-prognav');
                    const headerHeight = header ? header.offsetHeight : 0;
                    const offset = 20; // Additional padding from header

                    const elementPosition = questionDiv.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerHeight - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'auto'
                    });
                } else {
                    // Fallback to top if no question div found
                    window.scrollTo(0, 0);
                }
            });
        },

        // Auto-save when form data changes
        people: {
            deep: true,
            handler() {
                this.saveProgress();
            }
        },

        selectedMedication() {
            this.saveProgress();
            // Each medication has its own plan records, so switching has to repull them
            // or the new medication would be priced off the old one's plans.
            this.loadPlans();
        },

        selectedDosage() {
            this.saveProgress();
        },

        currentMedicationType() {
            this.saveProgress();
        },

        isTakingGLP1() {
            this.saveProgress();
        },

        'people.first_name'() {
            this.clearFieldError('first_name');
        },
        'people.last_name'() {
            this.clearFieldError('last_name');
        },
        'people.email'() {
            this.clearFieldError('email');
        },
        'people.phone'() {
            this.clearFieldError('phone');
        },
        'people.weight'() {
            this.clearFieldError('weight');
        },
        'people.height.foot'() {
            this.clearFieldError('height_foot');
        },
        'people.height.inches'() {
            this.clearFieldError('height_inches');
        },
        'people.state'() {
            this.clearFieldError('state');
        },
        'people.gender'() {
            this.clearFieldError('gender');
        },
        'people.dob.mm'() {
            this.clearFieldError('dob_mm');
        },
        'people.dob.dd'() {
            this.clearFieldError('dob_dd');
        },
        'people.dob.yyyy'() {
            this.clearFieldError('dob_yyyy');
        },
        paymentError(val) {
            if (val && this.errorMessage) {
                this.showToast(this.errorMessage);
            }
        },
        checkoutErrorMessage(val) {
            if (val) {
                this.showToast(val);
            }
        }
    }
}
</script>

<style scoped>
/* Plan badges — Popular / Recommended / Huge Savings */
.checkout_checkbox-field {
    position: relative;
    margin-bottom: 16px;
}
.plan-badge {
    position: absolute;
    top: -13px;
    left: 18px;
    z-index: 2;
    background-color: #d7fff0;
    color: #000;
    font-family: var(--satoshi, 'Satoshi', sans-serif);
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    padding: 6px 11px;
    border-radius: 999px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.huge-savings-btn {
    display: inline-block;
    margin-top: 3px;
    margin-bottom: 6px;
    background-color: #00c042;
    color: #fff;
    font-family: var(--satoshi, 'Satoshi', sans-serif);
    font-size: 8px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    pointer-events: none;
}
/* Stack the right-side "today" column vertically; pull it up so Huge Savings sits just under the price */
.checkout_checkbox-field._12mo .div-block-2242 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 2px;
    top: 15%;
}

.sms-disclaimer {
    color: #6c7e8d;
    font-size: 9px;
    line-height: 13px;
    margin-top: 6px;
    margin-bottom: 20px;
}
.sms-disclaimer a {
    color: #6c7e8d;
    text-decoration: underline;
}

.sms-consent-checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 12px;
    margin-bottom: 8px;
    padding: 0;
    cursor: pointer;
}
.sms-consent-checkbox .w-checkbox-input {
    margin-top: 3px;
    flex-shrink: 0;
}
.sms-consent-label {
    color: #6c7e8d;
    font-size: 11px;
    line-height: 15px;
    display: inline-block;
}
.sms-consent-checkbox.field-error .sms-consent-label {
    color: #e53e3e;
}

@keyframes consent-shake {
    0%, 100% { transform: translateX(0); }
    20% { transform: translateX(-8px); }
    40% { transform: translateX(8px); }
    60% { transform: translateX(-8px); }
    80% { transform: translateX(8px); }
}
.is-shaking {
    animation: consent-shake 0.5s ease-in-out;
}
/* Error Toast */
.error-toast {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 400px;
    background: #dc2626;
    color: #fff;
    padding: 16px 20px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    z-index: 99999999;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    animation: toast-in 0.3s ease, toast-out 0.3s ease 4.7s;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}
.error-toast span {
    flex: 1 1 auto;
    min-width: 0;
    overflow-wrap: break-word;
    word-break: break-word;
}
.toast-close {
    background: none;
    border: none;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    opacity: 0.8;
    flex-shrink: 0;
}
.toast-close:hover {
    opacity: 1;
}
@keyframes toast-in {
    from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
    to { opacity: 1; transform: translateX(-50%) translateY(0); }
}
@keyframes toast-out {
    from { opacity: 1; transform: translateX(-50%) translateY(0); }
    to { opacity: 0; transform: translateX(-50%) translateY(-20px); }
}

/* Address Blink */
.address-highlight :deep(input) {
    animation: blink-red 0.5s ease 3;
}
@keyframes blink-red {
    0%, 100% { border-color: inherit; }
    50% { border-color: #dc2626; box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.3); }
}

/* Express Checkout & Klarna */
.express-checkout-section {
    margin-bottom: 16px;
}

.express-checkout-box {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
}

.payment-request-btn-container {
    min-height: 48px;
}

.divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.divider-line {
    flex: 1;
    height: 1px;
    min-width: 0;
    background: #d8dbe0;
}

.divider span {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

.klarna-btn {
    width: 100%;
    background: #ffb3c7;
    color: #0b0b0b;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    font-family: inherit;
    height: 48px;
}

.klarna-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 179, 199, 0.5);
}

.klarna-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.klarna-btn-text {
    font-size: 16px;
    font-weight: 600;
}

.klarna-logo {
    height: 18px;
    width: auto;
}

.ns-card-element {
    border: 1px solid #d8dbe0;
    border-radius: 8px;
    padding: 14px;
    font-size: 15px;
    background: white;
    min-height: 48px;
    margin-bottom: 10px;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.form-group label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 6px;
}

/* Backdrop for the already-paid-user modal */
.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 99999;
}

.tosspan {
    position: absolute;
    font-size: 8px;
    bottom: -3px;
    color: gray;
}


.field-error {
    border: 2px solid #dc3545 !important;
    border-color: #dc3545 !important;
}

input.field-error,
select.field-error {
    border: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.enroll-checkbox-field.field-error {
    border: 2px solid #dc3545;
    border-radius: 4px;
    padding: 8px;
    background-color: rgba(220, 53, 69, 0.05);
}

.link-block-30.field-error {
    border: 2px solid #dc3545 !important;
    background-color: rgba(220, 53, 69, 0.05) !important;
}

input.field-error:focus,
select.field-error:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.w-input.field-error,
.w-select.field-error {
    border: 2px solid #dc3545 !important;
}

a.button-175.active.w-button img {
    width: 15px;
    margin-bottom: 3px;
}

/* Checkout Error Banner */
.checkout-error-banner {
    background: #fef2f2;
    border: 1px solid #fca5a5;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    margin-top: 15px;
}
.checkout-error-banner-content {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}
.checkout-error-icon {
    font-size: 20px;
    line-height: 1;
    flex-shrink: 0;
}
.checkout-error-text {
    flex: 1 1 auto;
    min-width: 0;
}
.checkout-error-heading {
    font-weight: 700;
    color: #991b1b;
    margin-bottom: 4px;
}
.checkout-error-message {
    color: #991b1b;
    margin-bottom: 4px;
    font-size: 14px;
    overflow-wrap: break-word;
    word-break: break-word;
}
.checkout-error-helper {
    color: #b91c1c;
    font-size: 13px;
    overflow-wrap: break-word;
    word-break: break-word;
}

@media screen and (max-width: 479px) {
    .express-checkout-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        padding: 16px;
        align-items: stretch;
    }
    .payment-request-btn-container {
        min-height: 48px;
    }
    .payment-request-btn-container:only-child {
        grid-column: 1 / -1;
    }
    .klarna-btn {
        flex-direction: column;
        padding: 4px 6px;
        gap: 2px;
        height: 48px;
        margin-top: 0;
    }
    .klarna-btn:only-child,
    .express-checkout-box.single-option .klarna-btn {
        grid-column: 1 / -1;
    }
    .klarna-btn-text {
        font-size: 11px;
        white-space: nowrap;
    }
    .klarna-logo {
        height: 16px;
    }
}

.email-error {
    border: 2px solid #e53e3e !important;
    background-color: #fff5f5 !important;
}

.error-message {
    color: #e53e3e;
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 10px;
}

.disabled-btn {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
}

.paid-user-modal {
    position: relative;
    background: #fff;
    border-radius: 16px;
    padding: 40px 32px 32px;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    text-align: center;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 16px;
    color: #1a1a1a;
    text-align: center;
}

.modal-close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 4px 8px;
    line-height: 1;
}

.modal-body p {
    font-size: 15px;
    line-height: 1.5;
    color: #555;
    margin: 0 0 24px;
    text-align: center;
}

.modal-btn {
    display: block;
    width: 100%;
    padding: 14px 22px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    margin-bottom: 10px;
}

.modal-btn-primary {
    background: #42cad1;
    color: #fff;
}

.modal-btn-secondary {
    background: #fff;
    color: #1a1a1a;
    border: 1px solid #e0e0e0;
    font-weight: 500;
}
.klarna-badge-flow {
    position: absolute;
    bottom: 8px;
    right: 20px;
    width: 56px;
    height: auto;
    z-index: 2;
}
@media screen and (max-width: 479px) {
    .klarna-badge-flow {
        width: 52px;
        bottom: 10px;
        right: 16px;
    }
}

.pe-label-7x {
    font-weight: 350 !important;
    color: #4a4a57 !important;
    font-size: 0.9rem !important;
    line-height: 1.15 !important;
    margin-bottom: 4px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}
@media screen and (max-width: 991px) {
    .pe-label-7x {
        font-size: 16px !important;
        color: #000 !important;
    }
}

.subscription-agreement {
    width: 75%;
}
.subscription-agreement p {
    width: 100%;
    margin: 0 0 6px;
}
.subscription-agreement p:last-child {
    margin-bottom: 0;
}
@media screen and (max-width: 479px) {
    .subscription-agreement {
        width: 100%;
    }

    /* Below 480px the webflow export turns this card into a column and pins the
       vial to 35% of its width. The row's align-items is stretch, so the tile
       and everything under it sat hard against the left edge with 200px of
       nothing beside them. The whole card centres on a phone; none of this
       applies at 480px and up, where the card is still a row. */
    .order-item-flex {
        align-items: center;
        text-align: center;
    }

    .order_img_div,
    .div-block-2241,
    .product-box-flex,
    .product-name-and-sub {
        align-self: center;
        align-items: center;
    }

    .checkout-dosage-div {
        justify-content: center;
    }
}
</style>